/**
* Primary KnockoutJS View Model for the QLess Calendar application
*
* @class QCalViewModel
*/

/// <reference type="Knockout">

var QCalViewModel = function () {
  var self;     // Convenience reference so the context of 'this' becomes clearer

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  // Creates a conventional reference to 'this'
  self = this;

  // The mini-calendar which appears in the sidebar
  self.minical = new KOMiniCalendar();

  // The primary view's working calendar
  self.cal = new KOCalendar();

  self.featureToggles = ko.observable({});

  self.now = new ko.observable(new moment());

  self.store = new Store();

  self.appointmentsPrinter = new AppointmentsPrinter();

  self.environmentProperties = ko.observable({
    "cia.googleIntegration.enabled": false,
  })

  // SHIM
  self.addAppointmentConsumerInfoStarted = function () { return false };
  self.currentWeek = ko.observable({ days: [] });
  self.monthName = function () { return ''; };
  self.timeBlockIntervalCSS = function () { return ''; };


  // Create an event connection
  self.event = new Event(self);

  // These observables refer to date numbers (integers) in order to quickly
  // increment, recall, or build a KOCalendar object
  self.currentDate = ko.observable(null);
  self.currentMonth = ko.observable(null);
  self.currentYear = ko.observable(null);


  // Create
  self.timeZoneControl = new TimeZoneControl();

  //self.availabilityIntervals = ['daily', 'weekly', 'monthly', 'yearly'];
  self.availabilityIntervals = ['daily', 'weekly', 'never'];

  // Array of strings to populate the Appointment Detail interface for changing a status manually
  self.appointmentStatuses = ko.observableArray(['PENDING', 'APPROVED', 'REJECTED']);
  self.appointmentStatusObjs = ko.observableArray([
    {
      name: 'Pending',
      val: 'PENDING'
    },
    {
      name: 'Approved',
      val: 'APPROVED'
    },
    {
      name: 'Rejected',
      val: 'REJECTED'
    }
  ]);

  // Array of hour number. Allows UI iteration over elements normally created literally in the DOM.
  self.availabilityHours = [];

  // Array of availability minutes. Allows UI iteration over elements normally created literally in the DOM.
  self.availabilityMinutes = [];

  // Create a collection of minute value objects from 1 to 60
  for (i = 0; i < 60; i = i + 5) {
    self.availabilityMinutes.push({
      value: i,
      display: (i < 10) ? '0' + i : i.toString()
    });
  }

  // Keeps track of the chosen day number when an availability detail is presented, so changes in recurrence
  // interval can be handled correctly
  self.availabilitySelectedDay = ko.observable(null);

  // Variable to determine which view is currently active in the calendar
  self.calendarViewType = ko.observable('week');

  // Instance to track the clear status message timeout
  self.clearStatusMessageTimer = null;

  //
  self.dayOfWeekNumbers = [0, 1, 2, 3, 4, 5, 6];


  self.dragStartY = ko.observable(null);

  // Set to true when the appointment is being edited and the status is rejected
  self.editAppointmentConfirming = ko.observable(false);

  // Variable to deterine the toolset and views to present
  self.globalViewType = ko.observable('calendars');

  // Array of hour number. Allows UI iteration over elements normally created literally in the DOM
  self.hourNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];


  self.iCalConf = ko.observable(false);

  // String to be displayed in the iCal modal window
  self.iCalUrl = ko.observable(null);

  self.icalShowNewAuth = ko.observable(true);

  self.locale = ko.observable('en');

  // Allows for searching of locations in sidebar when more than 10 are available
  self.locationSearch = ko.observable(null);

  //
  self.minuteIncrements10 = ko.observableArray([0, 10, 20, 30, 40, 50]);

  // Options for selecting recurring events
  self.recurrenceIntervalOptions = ko.observableArray(['Daily', 'Weekly', 'Monthly']);

  // Variable to determine which view is currently active in the resource mgmt
  self.resourceViewType = ko.observable('list');

  // A list of MomentJS dates
  self.resourceWeek = ko.observableArray([]);

  // SetTimeout hook for requesting queues
  self.queueRequestTimeout = null;

  // String to search existing appointments for
  self.searchFor = ko.observable(null);

  // Whether to include past appointments in the search results
  self.searchPast = ko.observable(false);

  // Contains a AvailabilityMode, selected from the manage resource availability interface
  self.selectedAvailability = ko.observable(null);

  // Contains a ResourceModel, selected from the manage resource list
  self.selectedResource = ko.observable(null);

  // Array of resources to show appointments for
  self.selectedResources = ko.observableArray([]);

  // Array of resources to include in the iCal export
  self.iCalSelectedResources = ko.observableArray([]);

  // The appointment to show the pop-up or edit detail for
  self.selectedAppointment = ko.observable(null);

  // Array of locations to show appointments for
  self.selectedLocationIds = ko.observableArray([]);

  // A transient look at the selectedLocationIds collection before new values are applied
  self.prevSelectedLocationIds = [];

  // Collection of the services selected in the UI
  self.selectedServices = ko.observableArray([]);

  // Controls whether rejected/cancelled appointments are displayed
  self.showAllAppointmentTypes = ko.observable(false);

  // Indicates whether the location selector is presented
  self.showLocationSelector = ko.observable(false);

  // Indicates whether the Open Availability selectors are presented
  self.showOpenAvailability = ko.observable(false);

  // String to be presented to the user in the header
  self.statusMessage = ko.observable(null);

  // Contains a string, derived from the TimeZone selector at top right of the interface
  self.timeZoneOffSet = ko.observable(0);

  ///
  /// SERVICE OBJECTS
  ///
  this.createServices();

  self.releaseNotesVM = new ReleaseNotesViewModel(self);
  // Instance of a data model representing what is needed to add an appointment
  self.addAppointmentTicket = new AddAppointmentTicket(self);
  self.resourceSelectionVM = new ResourceSelectionViewModel(self.locationsWS);
  self.editAppointmentVM = new EditAppointmentViewModel(
    self.locationsWS.getLocationById.bind(self.locationsWS),
    self.queuesWS.getQueue.bind(self.queuesWS),
    self.messagesWS,
    self.handleEditAppointmentClose.bind(self)
  );

  ///
  /// DEPENDENT OBSERVABLES
  ///

  self.addingAppointment = self.dependentObservable('addingTicket', self.addAppointmentWS);
  self.appointmentCount = self.dependentObservable('appointmentCount', self.appointmentsWS);
  self.locations = self.dependentObservable('locations', self.locationsWS);
  self.phoneMask = self.dependentObservable('phoneMask', self.messagesWS);
  self.resources = self.dependentObservable('resources', self.resourcesWS);
  self.services = self.dependentObservable('services', self.servicesWS);
  self.wssid = self.dependentObservable('wssid', self.wssidWS);



  ///
  /// OBSERVABLE SUBSCRIPTIONS
  ///


  // Create a subscription to observe the value of the selectedLocations collection
  // before the value changes. This allows the associated location resources to be
  // added to or removed from the selectedResources collection based on the state of
  // the location
  // In order to make this work, a new array has to be "constructed", else the value
  // will be based on an observable, which will be different by the time the 'change'
  // subscription is processed
  self.selectedLocationIds.subscribe(function (oldLocations) {
    self.prevSelectedLocationIds = oldLocations.slice();
  }, null, 'beforeChange');


  // Now create a subscription to the change event, to process the changes
  self.selectedLocationIds.subscribe(function (currentLocations) {

    var toggleResourcesDescriptor = self.resourceSelectionVM.toggleResourcesDescriptor(
      self.prevSelectedLocationIds, currentLocations
    );

    var selectedResources = self.selectedResources()
      .filter(function (resourceId) {
        // return Resource IDs that are NOT to be deselected
        return toggleResourcesDescriptor.toDeselect.indexOf(resourceId) == -1
      })
      .concat(toggleResourcesDescriptor.toSelect)

    self.selectedResources(selectedResources);

    self.setSticky('selectedLocationIds', currentLocations.join('|'));
  }, null, 'change');


	/**
   * Subscription to watch the changed value of the queue id in the
   * add appointment ticket, which is tied to the interface. When
   * this value changes, the corresponding TTs must be looked up and
   * either set or displayed (if there are more than one). Changes
   * against the TT will be handled in that subscription.
   *
   * @method loadPossibleTimeBlocks
   * @param {Number} iQueueId
   * @returns none
	*/
  self.loadPossibleTimeBlocks = function (iQueueId) {
    var aTTs = null;

    // Clear out any existing possible time blocks
    self.possibleTimeBlocksWS.blocks.removeAll();

    if (iQueueId != null) {
      // Set the queueId param on possibleTimeBlocksWS
      self.possibleTimeBlocksWS.queueId(iQueueId);

      // Get the Transaction Types for the selected queue
      aTTs = self.queuesWS.indexedQueues()[iQueueId].transactionTypes();

      // If there is only one queue, go ahead and set it on the
      // possibleTimeBlocks and the addAppointmentTicket. Otherwise,
      // allow the user to select the TT in the interface
      if (aTTs.length < 2) {

        // This looks like a hack, but this is required to allow
        // the observable collection time to bind to the UI elements
        // so it can then be selected
        self.possibleTimeBlocksWS.transactionTypeIds(aTTs[0].id);
        self.possibleTimeBlocksWS.doRequest(function () {

          // This function sets the view to the wee which contains
          // the first possible time block, in case it is not contained
          // within the current view.
          var firstBlockDate = null;

          // If the possibleTimeBlocksWS service returned data,
          // set the date view to the first found date
          if (qcal.possibleTimeBlocksWS.blocks().length > 0) {

            // Pull out the first (earliest) time block
            firstBlockDate = qcal.possibleTimeBlocksWS.blocks()[0].getDate();

            // Hijack a click handler method to set the view to the
            // first available date
            qcal.setCalDate({ 'date': firstBlockDate }, 'false');

            // Scroll the view to the hour of the first available
            // appointment spot
            qcal.scrollViewToHour(firstBlockDate);

          }
          else {
            // TODO
            // Handle no time blocks returned.
          }
        });


        setTimeout(function () {
          qcal.addAppointmentTicket.transactionTypeId(aTTs[0].id);
        }, 500);
      }

    }
    else {
      // Make sure the TT is rest
      self.addAppointmentTicket.transactionTypeId(null);
    }
  };


	/**
	 * Watch for the oAuthSel change and set the iCalSelectedResources
   * accordingly
	 */
  self.oauthWS.oAuthSel.subscribe(function (newVal) {
    var auth = null,		// OAuthModel
      res = null,			// ResourceModel
      resourceIds = [];

    if (newVal == null) {
      self.iCalSelectedResources.removeAll();
    }
    else {
      // Remove any previous selections
      self.iCalSelectedResources.removeAll();

      // Get the OAuthModel that was selected
      auth = self.oauthWS.getAuthById(newVal);

      if (auth) {
        // Get any ResourceSelection that corresponds to this OAuthModel
        res = self.resourceSetWS.getSetByName(auth.name);


        // Only bother proceeding if there are resources to select
        if (res && res.resources) {
          // Loop over all the individual resources in the resource set and extract
          // the IDs, pushing them into the resourceIds array
          resourceIds = res.resources.reduce(function (arr, r) {
            arr.push(r.locationResource.resourceId);
            return arr;
          }, []);


          // Loop over each available resource. If it's id is in the resourceIds
          // collection, add the ResourceModel to the iCalSelectedResources collection
          self.availableResources().forEach(function (res) {
            if (resourceIds.indexOf(res.id) > -1) {
              self.iCalSelectedResources.push(res.id);
            }
          });
        }
      }

    }
  }, null, 'change');




  ///
  /// COMPUTED OBSERVABLES
  ///


	/*
	* Collection of transaction types available, based on the selected queue id
	*
	* @method addAppointmentConsumerInfoVisible
	* @return {Boolean}
	*/
  self.addAppointmentConsumerInfoVisible = ko.computed(function () {
    var oTicket = self.addAppointmentTicket;	// Instance of the appointmentTicket

    // If the queue and TT have been selected, or the user has already filled in some of the consumer
    // info, then show the consumer info form
    return ((oTicket.queueId() != null && oTicket.transactionTypeId() != null) || self.addAppointmentConsumerInfoStarted());
  });


	/*
	* Collection of transaction types available, based on the selected queue id
	*
	* @method addAppointmentTransactionTypes
	* @return {Array} collection of TransactionTypeModels
	*/
  self.addAppointmentTransactionTypes = ko.computed(function () {
    var aReturn = [];
    var iQueueId = self.addAppointmentTicket.queueId();

    if (iQueueId != null) {
      aReturn = self.queuesWS.indexedQueues()[iQueueId].transactionTypes();
    }

    return aReturn;
  });


	/*
	* Limits the locations selectable when making an appointment to those that
	* have been selected in the left-hand sidebar
	*
	* @method appointmentLocations
	* @return {Array} collection of LocationModels
	*/
  self.appointmentLocations = ko.computed(function () {
    // Forces the computed to recalculate when the observable changes
    var aLocs = self.locationsWS.locations();

    return aLocs.filter(function (loc) {
      return (self.selectedLocationIds.indexOf(loc.id.toString()) > -1);
    });
  });


	/**
   * Method to retrieve all the appointments within the current
   * calendar week
	 *
	 * @type {KnockoutComputed<Array>} collection of AppointmentModels
	 */
  this.appointments_week = ko.computed(function () {
    // Forces calculation when observable changes
    var appointments = self.appointmentsWS.appointments(),
      tz = self.timeZoneControl.selectedTZ();

    // Only bother requesting appointments if there are any to request and
    // the view is appropriate to show them
    var isAppropriateView = (
      (self.calendarViewType() == "week") &&
      (['calendars', 'editAppointment'].indexOf(self.globalViewType()) > -1)
    )

    if (self.selectedLocationIds().length > 0 && appointments.length > 0 && isAppropriateView) {

      return self.currentWeek().days.reduce(function (arr, day) {
        // Capture the date for the current day
        var dt = day.date.date();

        arr.push({
          appointmentStartTimes: ko.observableArray(self.appointmentsWS.getAppointmentStartTimes(day.date))
        });

        return arr;

      }, []);
    }

    return [];
  });

  /**
   * Structures Appointments for the current Calendar month by week.
   * Updates when the Selected Time Zone is changed or Appointments are fetched.
   * 
   * @type {KnockoutComputed<Array>}
   */
  this.appointments_month = ko.computed(this._appointmentsViewMonth.bind(this), {
    owner: self,
    deferEvalution: true
  })

	/*
	* Observable to determine if time blocks in create a new appointment are visible
	* They should only be visible when adding a new appointment and all the required
	* information has been entered
	*
	* @method appointmentTimeBlocksVisible
	* @return {Boolean}
	*/
  self.appointmentTimeBlocksVisible = ko.computed(function () {
    var oTicket = self.addAppointmentTicket;

    if (self.globalViewType() == 'addAppointment') {

      // TODO - add in conditionals to validate consumer info
      if (oTicket.location() != null && oTicket.queueId() != null && oTicket.transactionTypeId() != null && self.addAppointmentConsumerInfoComplete()) {
        return true;
      }
    }
    else if (self.globalViewType() == 'openavailability') {
      return self.openAvailabilityVM.possibleBlocksWS.blocks().length > 0;
    }

    return false;
  });


	/**
	* This observable represents a collection of LocationModels based on the
	* selectedLocationIds collection (which is a grouping of IDs). This collection
	* is useful for showing/hiding resources / appointments / etc
	*
	* @method availableLocations
	* @return {Array} collection of LocationModels
	*/
  self.availableLocations = ko.computed(function () {
    var aReturn = [],	// Array to be returned
      i = 0;			// Standard increment

    // Loop over each location, and see if it's ID is in the collection of
    // selectedLocationIds. The selectedLocationIds will be strings, so convert
    // the location id to a string for comparison.
    for (i = 0; i < self.locations().length; i++) {
      if (self.selectedLocationIds.indexOf(self.locations()[i].id.toString()) > -1) {
        // If the id was found in the selectedLocationIds collection, add it to
        // the return collection
        aReturn.push(self.locations()[i]);
      }
    }

    return aReturn;
  });


	/**
	* Watches the availableLocations collection and asks the TimeZoneControl to
	* init with the available locations
	*
	* @method availableLocations.subscribe
	* @return none
	*/
  self.availableLocations.subscribe(function (val) {
    if (val && val.length > 0) {
      self.timeZoneControl.parseLocations(val);
    }
    else {
      self.timeZoneControl.reset();
    }
  });


	/**
	* Returns a collection of available resources based on the selected
	* (available) locations
	*
	* @method availableResources
	* @return {Array} collection of ResourceModels
	*/
  self.availableResources = ko.computed(function () {
    // Forces a calculation of the computed when changed
    var locs = self.availableLocations();

    return locs.reduce(function (arr, loc) {
      arr = arr.concat(loc.availableResources());

      return arr;
    }, []);
  });

	/**
	* Create a subscription to the available resources computed observable
	* in order to repaint the day view display when changed
	*/
  self.availableResources.subscribe(function (newVal) {
    self.resetDayViewInterface();
  });


  self.sidebarResources = ko.computed(function () {
    return self.selectedLocationIds().reduce(function (arr, id) {
      var loc = self.locationsWS.getLocationById(id);
      if (loc && loc.resources()) {
        arr = arr.concat(loc.resources());
      }
      return arr;
    }, []);
  });


	/**
	* This observable allows global UI switching of various sub-elements
	* of the UI based on the className(s) applied to the body element.
	*
	* @method bodyClass
	* @return {String} list of space-separated CSS classnames to apply
	*/
  self.bodyClass = ko.pureComputed(function () {
    var aClassNames = [];

    if (self.globalViewType() == 'resources') {
      aClassNames.push('resource-views');
    }
    else if (self.globalViewType() == 'addAppointment') {
      aClassNames.push('add-appointment-views');
    }
    else if (self.globalViewType() == "editAppointment") {
      aClassNames.push("edit-appointment-views");
    }
    else if (self.globalViewType() == 'searchResults') {
      aClassNames.push('search-results-views');
    }

    if (self.timeBlockIntervalCSS() != '') {
      aClassNames.push(self.timeBlockIntervalCSS());
    }

    if (self.showAllAppointmentTypes() == true) {
      aClassNames.push('all-appointments');
    }

    if (self.locations().length > 1 && self.hasAppointmentLocations() && self.showLocationSelector()) {
      aClassNames.push('locations-visible');
    }

    return aClassNames.join(' ');
  });


	/**
	* This observable creates a reference to an object structure for displaying
	* the calendar week view
	*
	* @method currentWeek
	* @return {Object} a Week object, defined within KOCalendar
	*/
  self.currentWeek = ko.computed(function () {
    return self.cal.currentWeek();
  });


	/**
	* Computed observable which returns the week number of the current week.
	* This is used in the data-bound UI to indicate different views. For example
	* this computed observable controls which week has highlighting in the
	* minical in the sidebar.
	*
	* @method currentWeekNo
	* @return {Integer} The week number of the current week (as selected by the user)
	*/
  self.currentWeekNo = ko.computed(function () {
    // Create a Moment object
    var m = new moment(),
      tz = self.timeZoneControl.selectedTZ();

    // The Date created will represent the current date as selected by the user
    // The user can select any date - future or past - by clicking a date in
    // the minical or by selecing a date in the main calendar view
    m.year(self.currentYear());
    m.month(self.currentMonth());
    m.date(self.currentDate());
    m.hour(0);
    m.minutes(0);
    m.seconds(0);

    if (tz) {
      m.tz(tz.olson[0]);
    }

    // Return the week number
    return m.week();
  });


	/**
	* Returns whether the day view button is available or not.
	* Presently, this button is only disabled when creating an appointment
	*
	* @method dayViewDisabled
	* @return {Boolean}
	*/
  self.dayViewDisabled = ko.computed(function () {
    return ['addAppointment', 'openavailability'].indexOf(self.globalViewType()) > -1;
  });


	/**
	* Returns a boolean indicating whether the location has locations available that have queues
	*
	* @method hasAppointmentLocations
	* @return {Boolean}
	*/
  self.hasAppointmentLocations = ko.computed(function () {
    // Forces the computed to calculate when changed
    var q = self.queuesWS.queues();

    if (self.queuesWS.data != null && self.locationsWS._locations().length > 0 && self.locations().length == 0) {
      return false;
    }

    return true;
  });


	/**
	* This computed observable returns a string for the mouse over
	* of a calendar navigation button
	*
	* @method hintCalNavButtonBack
	* @return {String}
	*/
  self.hintCalNavButtonBack = ko.computed(function () {
    return self.messagesWS.get('calendar.hint.navback') + ' ' + self.calendarViewType();
  });


	/**
	* This computed observable returns a string for the mouse over
	* of a calendar navigation button
	*
	* @method hintCalNavButtonNext
	* @return {String}
	*/
  self.hintCalNavButtonNext = ko.computed(function () {
    return self.messagesWS.get('calendar.hint.navforward') + ' ' + self.calendarViewType();
  });


	/**
	* This computed observable returns a string for the mouse over
	* hint for the refresh icon
	*
	* @method hintCalRefresh
	* @return {String}
	*/
  self.hintCalRefresh = ko.computed(function () {
    var msg = self.messagesWS.get('calendar.hint.refresh');

    return (msg != '') ? msg : 'refresh calendar';
  });


	/**
	* This computed observable returns a string for the mouse over
	* X icon on a resource availability block
	*
	* @method hintremoveAvailability
	* @return {String}
	*/
  self.hintremoveAvailability = ko.computed(function () {
    return self.messagesWS.get('calendar.availability.remove');
  });


	/**
	* This computed observable returns a true/false value which controls
	* the visiblity of the current hour indicator line in the UI.
	*
	* @method hourIndicatorVisible
	* @return {Boolean}
	*/
  self.hourIndicatorVisible = ko.computed(function () {
    var m = new moment(),
      tz = self.timeZoneControl.selectedTZ();

    if (tz) {
      m.tz(tz.olson[0]);
    }

    // If the calendar view is set to day
    if (self.calendarViewType() == 'day') {
      return self.cal.today().isSame(m, 'day');
    }
    // If the calendar view is set to week
    else if (self.calendarViewType() == 'week') {
      return self.cal.today().isSame(m, 'weeks');
    }

    // Otherwise the day is not current or the week is not current
    // do not show the indicator.
    return false;

  });


	/**
	* Provides a list of all selected resources at all selected locations
	*
	* @method iCalResources
	* @return {Array} aResources A collection of resources, plus an initial
	*                 Select All option
	*/
  self.iCalResources = ko.computed(function () {
    var aAllResourceIds = [],	// Array of all resource IDs found
      aResources = [],		// Array of resources to be returned
      locs = self.availableLocations();

    locs.forEach(function (loc, idx) {
      var aResourceIds = [];

      loc.availableResources().forEach(function (res) {
        aResourceIds.push(res.id);
        aAllResourceIds.push(res.id);
      });

      if (aResourceIds.length > 0 && idx > 1) {
        aResources.push({
          name: loc.name,
          id: aResourceIds.join(','),
          className: 'icalExportLocation'
        });
      }

      loc.availableResources().forEach(function (res) {
        var obj = {
          name: '   ' + res.name,
          id: res.id
        };

        if (idx > 1) {
          obj['className'] = 'icalExportResource';
        }

        aResources.push(obj);
      });
    });

    return [{
      name: self.messagesWS.get('calendar.ical.allcalendars'),
      id: aAllResourceIds.join(','),
      className: 'icalExportAll'
    }].concat(aResources);
  });

  /**
  * Controls if the print button is displayed
  *
  * @method displayPrintButton
  * @returns {Boolean}
  */
  self.displayPrintButton = ko.computed (function () {
    return self.calendarViewType() === "day" ? true : false;
  })


  /**
  * Retrieves authentication cookies
  *
  * @method isAuthenticated
  * @returns {Boolean}
  */
  self.isAuthenticated = function () {
    var bFoundAuthCookie = false,
      cookies = document.cookie.split(';');

    if (cookies.length > 0) {
      if (self.store.get('au') != null) {
        bFoundAuthCookie = true;
      }
      else {
        cookies.forEach(function (cookie) {
          var parts = cookie.trim().split('=');

          if (parts[0].indexOf('au__') > -1) {
            bFoundAuthCookie = true;
          }
        });
      }

    }

    // If there was no auth cookies found, return false
    return bFoundAuthCookie;
  };


	/**
	* Observable to determine if authenticated user has access to administer
	* location resources. By looking at the AuthInfoWS roles and the
	* selectedLocationIds, a true value will be returned if the user has the role
	* resourceAdmin.location.[location_id]
	*
	* @method isResourceAdmin
	* @return {Boolean}
	*/
  self.isResourceAdmin = ko.computed(function () {
    var locationIds = self.selectedLocationIds();
    var roles = self.authInfoWS.roles();

    return locationIds.filter(function (locId) {
      return roles.indexOf('resourceAdmin.location.' + locId) > -1;
    }).length > 0;
  });

  self.showCalendarIntegrationButton = ko.computed(function() {
    return self.featureToggles().ciaEnabled && self.authInfoWS.hasRole('merchConfigAccountsAdmin');
  });

	/**
	* Collection of locations available in the left-hand sidebar
	*
	* @method listLocations
	* @return {Array}
	*/
  self.listLocations = ko.computed(function () {
    var locs = self.locations(),
      val = self.locationSearch();

    if (val != null) {
      return locs.reduce(function (arr, loc) {
        if (loc.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
          arr.push(loc);
        }

        return arr
      }, []);
    }

    return locs;
  });


	/**
	* This computed observable returns a string for the location toggle button
	*
	* @method locationsLabel
	* @return {String}
	*/
  self.locationsLabel = ko.computed(function () {
    var sReturn = self.messagesWS.get('calendar.locations.showing') + ' ';

    if (self.locations().length == 0) {
      // Locations are still being loaded
      if (self.hasAppointmentLocations()) {
        return self.messagesWS.get('calendar.locations.loading');
      }
      // If locations were loaded but no locations with appointments were
      // found, let the user know.
      else {
        return 'No appointment locations'; //self.messagesWS.get('calendar.noappt.locations');
      }
    }

    if (self.selectedLocationIds().length == self.locations().length) {
      sReturn += self.messagesWS.get('calendar.locations.all');
    }
    else if (self.selectedLocationIds().length == 0) {
      return self.messagesWS.get('calendar.locations.selectlocations');
    }
    else {
      sReturn += self.selectedLocationIds().length;
    }

    return sReturn + ' ' + ((self.selectedLocationIds().length == 1) ? self.messagesWS.get('calendar.locations.location') : self.messagesWS.get('calendar.locations.locations'));
  });


	/**
	* Determines whether to add a CSS className to hide the locations label/toggle
	*
	* @method locationsLabelHidden
	* @return {Boolean}
	*/
  self.locationsLabelHidden = ko.computed(function () {
    return !(self.globalViewType() == 'calendars' && (self.locations().length > 1 || !self.hasAppointmentLocations()))
  });

  /**
	* Returns true if we are currently viewing appointment calendars day/week/month
	*
	* @method mainSupplementVisible
	* @return {Boolean}
	*/
  self.mainSupplementVisible = ko.computed(function () {
    return self.globalViewType() == 'calendars';
  });


  /**
  * This computed observable examines the calendarViewType and returns
  * a Consumer-friendly string indicating the range of dates in the
  * current view.
  *
  * @method mainViewDescription
  * @return {String}
  */
  self.mainViewDescription = ko.computed(function () {
    var firstDay = null,
      format = '',
      lastDay = null,
      today = self.cal.today();

    // If the current view is week, show the range of dates (month/day number)
    // for the first and last days of the current week
    if (self.calendarViewType() == 'week') {
      format = 'll';
      firstDay = self.currentWeek().days[0].date;
      lastDay = self.currentWeek().days[6].date;

      return firstDay.format(format) + ' - ' + lastDay.format(format);
    }
    // If the current view is month, show the month name and year
    else if (self.calendarViewType() == 'month') {
      format = 'MMMM YYYY';
    }
    // If the current view is day, show the full date string ( Mon Oct 19, 2015)
    else {
      format = 'LL';
    }

    return today.format(format);
  });


  /**
  * Shows the month name and year for the minical
  *
  * @method minicalDateDisplay
  * @return {String}
  */
  self.minicalDateDisplay = ko.computed(function () {
    return self.minical.cal.today().format('MMMM YYYY');
  });


  /**
  * Returns whether the month view button is available or not.
  * Presently, this button is only disabled when creating an appointment
  *
  * @method monthViewDisabled
  * @return {Boolean}
  */
  self.monthViewDisabled = ko.computed(function () {
    return ['addAppointment', 'openavailability'].indexOf(self.globalViewType()) > -1;
  });


  /*
  * This computed observable is necessary due to the way data binding is done in the new
  * appointment form. A collection bound to qcal.addAppointmentTicket.location().queues will
  * fail because at the time the app is loaded, qcal.addAppointmentTicket.location() is null
  * and has no members. This observable allows a work around to that.
  *
  * @method newAppointmentLocationQueues
  * @return {Array}
  */
  self.newAppointmentLocationQueues = ko.computed(function () {
    // If there is a selected location, return it's queues
    return (self.addAppointmentTicket.location() != null) ? self.addAppointmentTicket.location().queues() : [];
  });


  /**
  * Returns an array of possibleTimeBlocks that occur in the displayed week
  *
  * @method possibleTimeBlocks_week
  * @return {Array} Array of possibleTimeBlocks, grouped by days 0-6
  */
  self.possibleTimeBlocks_week = ko.computed(function () {
    var blocks = self.possibleTimeBlocksWS.blocks();

    // If we are not looking at the add appointment page, don't bother
    // interrogating the possibleTimeBlocksWS
    if (self.globalViewType() == 'addAppointment') {
      return self.currentWeek().days.reduce(function (arr, day) {
        arr.push(self.possibleTimeBlocksWS.timeBlocksGroupedByDate(day.date));

        return arr;
      }, []);
    }
    else if (self.globalViewType() === 'openavailability') {
      return self.currentWeek().days.reduce(function (arr, day) {
        arr.push(self.openAvailabilityVM.possibleBlocksWS.timeBlocksGroupedByDate(day.date));

        return arr;
      }, []);
    }

    return [];
  });


  /**
   * Returns a string to convey the currently displayed week range
   * for the resource availability screen
   *
   * @method resourceWeekLabel
   * @return {String}
   */
  self.resourceWeekLabel = ko.computed(function () {
    var days = self.resourceWeek();

    if (days.length > 0) {
      var from = days[0].format('MMM D, YYYY');
      var to = days[6].format('MMM D, YYYY');
      return from + ' - ' + to;
    }

    return '';
  });


  /**
  * Returns an collection of queue IDs that belong to the selected locations
  *
  * @method selectedQueueIds
  * @return {Array}
  */
  self.selectedQueueIds = ko.computed(function () {
    var oLoc = null;	// LocationModel

    // Loop over all the selectedLocation IDs
    return self.selectedLocationIds().reduce(function (arr, locId) {

      // Grab a LocationModel by referencing it in the indexedLocations hash
      oLoc = self.locationsWS.indexedLocations()[parseInt(locId)];

      // Loop over each queue in the LocationModel, and grab each ID
      oLoc.queues().forEach(function (q) {
        arr.push(q.id);
      });

      return arr;
    }, []);
  });


  /**
  * Watches the selectedQueueIds observable and asks for new appointments with the
  * list of IDs
  *
  * @method selectedQueueIds.subscribe
  * @return none
  */
  self.selectedQueueIds.subscribe(function (val) {
    self.appointmentsWS.doRequest();
  })


  /**
  * Returns an string to display how many resources are selected when the resources
  * sidebar is collapsed
  *
  * @method selectedResourceCountMsg
  * @return {String} message indicating how many resources are selected
  */
  self.selectedResourceCountMsg = ko.computed(function () {
    var aAvailableResources = self.availableResources();
    var aSelResources = self.selectedResources();
    var aTemp = [];
    var len = 0;

    aTemp = aAvailableResources.reduce(function (arr, res) {
      if (aSelResources.indexOf(res.id.toString()) > -1) {
        arr.push(res);
      }

      return arr;
    }, []);


    len = aTemp.length;

    if (len === 0) {
      return '';
    }

    return '(' + len + ')';
  });


  /**
  * Returns the name of the location which the selectedResource belongs to
  *
  * @method selectedResourceLocationName
  * @return {String}
  */
  self.selectedResourceLocationName = ko.computed(function () {
    if (self.selectedResource() != null) {
      return self.locationsWS.indexedLocations()[self.selectedResource().locationId()].name;
    }

    return '';
  });


  /**
  * A timezone string of the location the selected resource belongs to
  *
  * @method selectedResourceTimeZone
  * @return {String}
  */
  self.selectedResourceTimeZone = ko.computed(function () {
    if (self.selectedResource() != null) {
      return self.locationsWS.indexedLocations()[self.selectedResource().locationId()].timeZone;
    }

    return '';
  });


  /**
  * Returns an CSS classname related to the minDuration value derived
  * from possibleTimeBlocksWS or appointmentsWS
  *
  * @method timeBlockIntervalCSS
  * @return {String} CSS Classname
  */
  self.timeBlockIntervalCSS = ko.computed(function () {
    var iInterval = self.appointmentsWS.minDuration();

    if (self.possibleTimeBlocksWS.blocks().length > 0) {
      iInterval = self.possibleTimeBlocksWS.minDuration();
    }

    return 'timeblock-interval-' + iInterval;
  });



  ///
  /// Button-invoked/Click-handled methods
  ///


  /**
  * Click-handled function
  * This method responds to a button in the UI's header and sets the interface
  * back to the calendar view
  *
  * @method addNewAppointmentHide
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.addNewAppointmentHide = function (data, evt) {
    self.globalViewType('calendars');
    self.appointmentsWS.doRequest();

    self.addAppointmentWS.reset();

    // Remove any possible time blocks (TimeBlockModels) as we are now in view
    // mode, so this data should no longer be required.
    // If an appointment was created, the interface will be resized to accomodate
    // that new data, otherwise, return the interface to it's default view state
    self.possibleTimeBlocksWS.reset();
  };


  /**
  * Click-handled function
  * This method responds to a button in the UI's header and sets the interface
  * for adding a new appointment
  *
  * @method addNewAppointmentShow
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.addNewAppointmentShow = function (data, evt) {
    // Hide the open availability selector
    self.toggleOpenAvailability(false);

    // Reset the appointment ticket
    self.addAppointmentTicket.reset();

    // Appointments can only be made in week view
    self.calendarViewType('week');

    // Remove any previously selected resource. Start fresh.
    self.selectedResource(null);

    // Clear any search that may have been performed
    self.searchWS.reset();

    // Hide any visible modal windows
    self.hideAllModals(null, evt);
    self.modalHide();

    // Set a cookie that can be recalled later
    self.setSticky('activeview', 'week');

    // Change the view type
    self.globalViewType('addAppointment');

    self.addAppointmentTicket.init();

    return false;
  };


  /**
  * Click-handled function
  * Removes the appointment detail popup and reset the selectedAppointment variable
  *
  * @method appointmentPopupHide
  * @return {Boolean} true
  */
  self.appointmentPopupHide = function (data, evt) {
    if (self.selectedAppointment() != null) {
      self.selectedAppointment(null);

      $('.appointment-detail').css({
        top: '-2000px',
        left: '-2000px'
      });
    }

    return true;
  };


  /**
  * Click-handled function
  * Prevents the hide action from taking place
  *
  * @method appointmentPopupHideBlock
  * @return {Boolean} false
  */
  self.appointmentPopupHideBlock = function (data, evt) {
    evt.stopPropagation();
    return false;
  };


  /**
  * Click-handled function
  * Displays a tooltip-like interface showing appointment details
  *
  * @method appointmentPopupShow
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.appointmentPopupShow = function (data, evt) {

    self.selectAppointment(data);

    // Fetch the Appointment details JIT
    self.appointmentsWS.fetchAppointment(data.id, function (detailedAppointmentData) {
      setTimeout(function () {
        data.loadDetailsAndLanguageName(detailedAppointmentData, self.messagesWS)
      })
    })

    var bodyHeight = $('body').outerHeight(),
      bodyWidth = $('body').outerWidth(),
      elTgt = $('.appointment-detail'),
      elTgtW = elTgt.outerWidth(),
      elTgtH = elTgt.outerHeight(),
      tgtX = Math.max(0, evt.clientX - (elTgtW / 2)),
      tgtY = Math.max(0, evt.clientY - elTgtH);

    evt.stopPropagation();

    if ((tgtX + elTgtW) > bodyWidth) {
      tgtX = (bodyWidth - elTgtW - 5);
    }

    if ((tgtY + elTgtH) > bodyHeight) {
      tgtY = (bodyHeight - elTgtH - 5);
    }

    elTgt.css({
      top: tgtY + 'px',
      left: tgtX + 'px'
    });

    return false;
  };


  /**
  * Click-handled function
  * Calls to remove a Resource AvailabilityModel
  *
  * @method availabilityDelete
  * @param {Object} data AvailabilityModel
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.availabilityDelete = function (data, evt) {
    var oAvailabilityModel = data;

    self.availabilityDetailHide(data, evt);

    if (oAvailabilityModel != null) {
      self.resourceAvailabilityWS.removeAvailability(oAvailabilityModel);
    }
  };


  /**
  * Click-handled function
  * Cancels the interface to remove a Resource AvailabilityModel
  *
  * @method availabilityDeleteCancel
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean}
  */
  self.availabilityDeleteCancel = function (data, evt) {
    $('.availability-detail-delete-confirm').removeClass('availability-detail-delete-confirm-show');
    return false;
  };


  /**
  * Click-handled function
  * Prompts the user to confirm they wish to remove a resource availability block
  *
  * @method availabilityDeleteConfirm
  * @param {AvailabilityModel} data AvailabilityModel to delete
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.availabilityDeleteConfirm = function (data, evt) {
    evt.stopPropagation();
    $('.availability-detail-delete-confirm').addClass('availability-detail-delete-confirm-show');
    return false;
  };


  /**
  * Click-handled function
  * Method to hide the availability detail interface
  *
  * @method availabilityDetailHide
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} true
  */
  self.availabilityDetailHide = function (data, evt) {
    if (evt && self.selectedAvailability() != null) {
      self.selectedAvailability(null);

      self.availabilitySelectedDay(null);

      $('.availability-detail').css({
        top: '-2000px',
        left: '-2000px'
      });
    }

    return true;
  };


  /**
  * Click-handled function
  * Prevents the hide action from taking place
  *
  * @method availabilityDetailHideBlock
  * @return {Boolean} false
  */
  self.availabilityDetailHideBlock = function (data, evt) {
    evt.stopPropagation();
    return false;
  };


  /**
  * Click-handled function
  * Method to show the availability detail interface
  *
  * @method availabilityDetailShow
  * @param {AvailabilityModel} availabilityModel
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.availabilityDetailShow = function (availabilityModel, evt) {
    if ($(evt.target).hasClass('availability-drag')) {
      return
    }

    self.availabilitySelectedDay($(evt.target).parents('ul').attr('data-index'));
    self.selectedAvailability(availabilityModel);

    var bodyHeight = $('body').outerHeight(),
      bodyWidth = $('body').outerWidth(),
      elTgt = $('.availability-detail'),
      elTgtW = elTgt.outerWidth(),
      elTgtH = elTgt.outerHeight(),
      tgtX = Math.max(0, evt.clientX - (elTgtW / 2)),
      tgtY = Math.max(0, evt.clientY - elTgtH);

    evt.stopPropagation();

    if ((tgtX + elTgtW) > bodyWidth) {
      tgtX = (bodyWidth - elTgtW - 5);
    }

    if ((tgtY + elTgtH) > bodyHeight) {
      tgtY = (bodyHeight - elTgtH - 5);
    }

    elTgt.css({
      top: tgtY + 'px',
      left: tgtX + 'px'
    });

    return false;
  };


  /**
  * Click-handled function
  * Method responds to a click in the appointment detail window and begins the service early
  *
  * @method beginService
  * @param {AppointmentModel} data AppointmentModel
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.beginService = function (data, evt) {
    if (!$(evt.target).hasClass('btn-disabled')) {

      // TODO: ES6 destructuring would be nice here
      self.serviceTransactionStartWS.startServiceTransaction(
        {
          appointmentId: data.id,
          locationId: data.locationId,
          queueId: data.queueId,
          phone: data.phone,
          partySize: data.partySize,
          notes: data.notes,
          firstName: data.firstName,
          lastName: data.lastName,
          transactionTypeId: data.transactionType.id
        }, 
        function () {
          // Once the session has been started change the status to STARTED_EARLY
          self.updateAppointmentStatusWS.update(data.id, "SERVED_EARLY");
        }
      );

      $(evt.target).addClass('btn-disabled');
    }

    return false;
  };


  /**
   * Click-handled function
   * This method changes the main calendar current view, moving the current
   * view forward or backward by one unit (month, week, day), depending on
   * the data-direction of the button clicked.
   *
   * @method changeCalView
   * @param {Object} data Not used
   * @param {Event} evt The UI event which triggered the call to the function
   * @return none
   */
  self.changeCalView = function (data, evt) {
    // Determine if the view is to be incremented or decrimented by a unit(s)
    // This is set to 1/-1 in the UI, but any valid integer will work
    var iChange = parseInt(evt.target.getAttribute('data-direction'), 0);

    // Determine what the current view is, and call the appropriate change function
    // Note that moving the main view forward or backward will also move the minical.
    switch (self.calendarViewType()) {
      case 'month':
        self.cal.changeMonth(iChange, function () {
          qcal.minical.buildMonth(qcal.cal.startDate(), true);
        });
        break;

      case 'week':
        self.cal.changeWeek(iChange, function () {
          qcal.minical.buildMonth(qcal.cal.currentWeek().days[0].date, true);
        });
        break;

      case 'day':
        self.cal.changeDate(iChange, function () {
          qcal.minical.buildMonth(qcal.cal.today(), true);
        });
        break;
    }

    if (self.globalViewType() === 'addAppointment') {
      self.possibleTimeBlocksWS.doRequest();
    }
    else if (['calendars', 'editAppointment'].indexOf(self.globalViewType()) !== -1) {
      self.appointmentsWS.doRequest();
    }
    else if (self.globalViewType() === 'openavailability') {
      self.openAvailabilityVM.findAvailability();
    }

    // Once the main calendar has been moved, update the observable variables
    // to reflect the current state in the UI
    self.updateCurrentDate();
  };


  /**
  * Click-handled function
  * This method changes the mini calendar current view, moving the current view
  * forward or backward by one month, depending on the data-direction
  * of the button clicked.
  *
  * @method changeMinicalMonth
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.changeMinicalMonth = function (data, evt) {
    // Determine if the view is to be incremented or decrimented by a unit(s)
    // This is set to 1/-1 in the UI, but any valid integer will work
    var iChange = evt.target.getAttribute('data-direction');

    // Call the KOCalendar method to change the month by [iChange] units
    self.minical.changeMonth(iChange);
  };


  /**
  * Click-handled function
  * This method respondes to the timezone selection on the toolbar being changed
  * It fires off a method to update the hour indicator
  *
  * @method changeTimeZone
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.changeTimeZone = function (data, evt) {
    self.appointmentPopupHide();
    self.clearStatusMessage();
    self.updateHourIndicator();
  };


  /**
  * Click-handled function
  * Submits the search form when the enter key is pressed
  *
  * @method checkSearchSubmit
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean}
  */
  self.checkSearchSubmit = function (data, evt) {
    if (evt.keyCode == 13) {
      self.searchWS.doRequest();
    }

    return true;
  };


  /**
  * Click-handled function
  * Watches for the tab key in the search input and focuses on the Go button
  *
  * @method checkSearchTab
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean}
  */
  self.checkSearchTab = function (data, evt) {
    if (evt.keyCode == 9) {
      $('#searchInput').blur();
      $('#searchSubmit').focus();
      return false;
    }

    return true;
  };


  /**
  * Click-handled function
  * Responds to a change of appointment status to REJECTED in the appointment detail
  * pop-up and presents an overlay within that interface, confirming the user wishes
  * to reject the appointment
  *
  * @method confirmPopupDelete
  * @param {AppointmentModel} [optional] AppointmentModel model to pass
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.confirmPopupDelete = function (AppointmentModel) {
    if (self.globalViewType() == 'searchResults') {
      setTimeout(function () {
        self.confirmDeleteModalShow(AppointmentModel);
      }, 200);
    }
    else {
      $('.appointment-detail-delete-confirm').addClass('appointment-detail-delete-confirm-show');
    }
    return false;
  };


  /**
  * Click-handled function
  * Responds to a click of the "No" button in the above triggered interface.
  * Hides the confirmation UI
  *
  * @method confirmPopupDeleteCancel
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.confirmPopupDeleteCancel = function (data, evt) {
    $('.appointment-detail-delete-confirm').removeClass('appointment-detail-delete-confirm-show');
    return false;
  };


  /**
  * Hides the window to reject an appointment from search results
  *
  * @method confirmDeleteModalHide
  * @return none
  */
  self.confirmDeleteModalHide = function (data, evt) {
    self.selectedAppointment(null);

    $('.reject-appointment').css({
      top: '-2000px',
      left: '-2000px'
    });

    return true;
  };


  /**
  * Presents a modal window allowing the consumer to reject an appointment
  * from search resutls
  *
  * @method confirmDeleteModalShow
  * @return none
  */
  self.confirmDeleteModalShow = function (AppointmentModel) {
    self.selectAppointment(AppointmentModel);

    var elTgt = $('.reject-appointment'),
      elTgtW = elTgt.outerWidth(),
      elTgtH = elTgt.outerHeight();

    elTgt.css({
      top: 'calc( 50% - ' + Math.floor(elTgtH / 2) + 'px)',
      left: 'calc( 50% - ' + Math.floor(elTgtW / 2) + 'px)'
    });

    return true;
  };


  /**
   * Ensures that a custom screen field is only rendered to the
   * add appointment interface once
   *
   * @method customScreenFieldIsUnique
   * @param {Object} field
   * @param {Number} screenIdx
   * @return {Boolean}
   */
  self.customScreenFieldIsUnique = function (field, screenIdx) {
    // Make sure the addAppointmentTicket has a location
    var loc = self.addAppointmentTicket.location();
    // If there is a location, grab the custom screens, or init an array
    var screens = (loc) ? loc.customScreens() : [];
    // If there are screens to iterate over, do this
    if (screens.length > 0) {
      // Get the fields that match the field value passed as a param by
      // looping over each screen, examining it's fields array, and returning
      // all fields that match the name of the field passed as the parameter
      var matchingFields = screens.reduce(function (arr, scrn, idx) {
        // If the screen had fields, iterate over each field, looking for
        // one with a matching name
        if (scrn.fields().length > 0) {
          // Filter each field, only returning the ones which match the name
          // of the field passed as the param
          arr = arr.concat(scrn.fields().filter(function (fld) {
            // If the screen is no greater than the field's screen
            // (this prevents fields on earlier screens matching against
            // fields that would come after them; the ones that come after
            // are the duplicates, not the earlier instances)
            // and the field is not the iterated field, and they have the
            // same name, return that one
            return idx <= screenIdx && fld !== field && fld.name == field.name;
          }));
        }
        // return the array of fields from each screen
        return arr;
      }, []);

      // If there were no matching fields, then the passed field is unique
      return matchingFields.length == 0
    }

    // If there are no screens to iterate over, then whatever was
    // passed must be unique.
    return true;
  };


  /**
  * Click-handled function
  * Responds to a click in the Manage Resource List, moving the user to the edit
  * resource availability interface.
  *
  * @method editResourceAvailability
  * @param {Object} data ResourceModel
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.editResourceAvailability = function (data, evt) {
    // Set the selectedResource observable to the item which was clicked
    // Not to be confused with selectedResources, which represents the IDs
    // of the resource checkboxes in the sidebar.
    self.selectedResource(data);

    self.resourceViewType('availability');
    self.calendarViewType('week');

    self.resourceAvailabilityWS.resourceId(data.id);
    self.resourceAvailabilityWS.doRequest();

    self.initSelectable();

    return false;
  };


  self.initSelectable = function () {
    // Remove any existing selectability so as not to have concurrent triggers
    try {
      $('.availability-day-hours').selectable('destroy');
    }
    catch (e) { }

    // Invoke fresh selectable triggers
    $('.availability-day-hours:not(.holiday-block)').selectable({
      start: qcal.availabilityDetailHide,
      stop: qcal.selectAvailabilityRange
    });
  };


  /**
  * Click-handled function
  * This method hides any appointment detail or availability recurrence pop-ups
  *
  * @method hideAllModals
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.hideAllModals = function (data, evt) {
    // NOTE: This function is called by other fns, not just triggered via UI events.
    // There is also logic not hide a modal now.
    // So, this Fn needs to be revisted and renamed, perhaps to `hideModal` with
    // some kind of options controlling what will be hidden.
    self.appointmentPopupHide();
    self.confirmDeleteModalHide();

    var datepickerClicked =
      evt && evt.target && (
        $(evt.target).parents("#ui-datepicker-div").length != 0 ||
        $(evt.target).parents(".ui-datepicker-header").length != 0
      );

    if (!datepickerClicked) {
      self.availabilityDetailHide(null, true);
    }

    return true;
  };


  /**
  * Click-handled function
  * This method changes the main and mini calendars current view to 'today',
  * as determined by the browser to be today's date.
  *
  * TODO - Should today be reliant on the browser, or should we retrieve this
  * value from the service, to account for computers with incorrectly set
  * clocks
  *
  * @method jumpToToday
  * @param {Object} data Not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.jumpToToday = function (data, evt) {
    // invoke the time reset and set the value of self.now()
    self.getCurrentTime()

    // Update the main and mini calendars to the current date
    self.minical.buildMonth(self.now());
    self.cal.buildMonth(self.now());

    if (self.globalViewType() == 'addAppointment') {
      self.possibleTimeBlocksWS.doRequest();
    }
    else if (self.globalViewType() == 'calendars') {
      self.appointmentsWS.doRequest();
    }

    // Once the calendars has been moved, update the observable variables
    // to reflect the current state in the UI
    self.updateCurrentDate();
  };


  /**
  * Click-handled function
  * This method responds to a button in the UI meant to hide a modal
  * window. All modal windows will be hidden, as only one modal window
  * can be on screen at once.
  *
  * @method modalHide
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.modalHide = function (data, evt) {
    // Hide all modals
    $('.modal-visible').removeClass('modal-visible');
  };


  /**
  * Click-handled function
  * This method responds to a button in the UI meant to invoke a modal
  * window. It will hide any currently active modal windows and then
  * make visible the requested modal window
  *
  * @method modalShow
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.modalShow = function (data, evt) {
    var fInitMethod = evt.target.getAttribute('data-init');
    var targetName = evt.target.getAttribute('data-modal');

    // Hide all modals
    self.modalHide();

    // If there is a data-init attribute, it contains the name of the
    // function required to initialize the window before it is presented
    if (fInitMethod) {
      self[fInitMethod]();
    }

    // Show the specified modal window
    $('#' + targetName).addClass('modal-visible');
  };


  self.fromQM = function () {
    return document.referrer.toLowerCase().indexOf('/qless') > -1
  };


  /**
   * Sets the link back to Queue Manager, depending on where it came from
   *
   * @method qmLink
   * @return {String}
   */
  self.qmLink = function () {
    var ref = document.referrer.toLowerCase();

    if (ref.indexOf('/cec/') > -1 || ref.indexOf('/qm/') > -1) {
      return ref;
    }

    return '/qless/merchant';
  };


  /**
  * Click-handled function
  * Refreshes the current calendar view
  *
  * @method refreshCalendar
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.refreshCalendar = function (data, evt) {
    self.appointmentsWS.doRequest();

    return false;
  };


  /**
  * Click-handled function
  * This method handles clicks originating from the appointment detail pop-up
  * and attempts to remove an existing appointment
  *
  * @method removeAppointment
  * @param {Object} data Data-bound object or a KOCalendar
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.rejectAppointment = function (data, evt) {
    var iAppointmentId = (self.selectedAppointment() != null) ? self.selectedAppointment().id : null;

    self.hideAllModals();

    if (iAppointmentId != null) {
      qcal.updateAppointmentStatusWS.update(iAppointmentId, 'REJECTED_EXPLICITLY');
      qcal.appointmentsWS.setAppointmentStatus(iAppointmentId, 'REJECTED');
      qcal.searchWS.setAppointmentStatus(iAppointmentId, 'REJECTED');
    }
  };


  /**
  * Function ensures that the day view interface is wide enough to handle all
  * displayed resources
  *
  * @method resetDayViewInterface
  * @return none
  */
  self.resetDayViewInterface = function () {
    // Start by setting the interface width back so it is not
    // causing the push
    $('#dayHourContainer').css('min-width', '100px');

    // Now set a small timeout to repaint the interface with the
    // calculated width
    clearTimeout(self.dayViewInterfaceTimer);

    self.dayViewInterfaceTimer = setTimeout(function () {
      var newWidth = $('.day-view')[0].scrollWidth;
      $('#dayHourContainer').css('min-width', newWidth + 'px');
    }, 500);
  }

  /**
  * Click-handled function
  * Method to call save action from the modal interface
  *
  * @method resourceAvailabilitySave
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.resourceAvailabilitySave = function (data, evt) {
    self.resourceAvailabilityWS.save();
    self.resourceAvailabilityWS.holidayAdded(false);
  };

  self.resourceWeekNext = function () {
    self.setResourceWeek(1);
  };

  self.resourceWeekPrev = function () {
    self.setResourceWeek(-1);
  };


  /**
  * Click-handled function
  * This method handles clicks originating from the minical or the main calendar
  * month view and sets the "current date" to the date clicked
  *
  * @method setCalDate
  * @param {Object} data Data-bound object or a KOCalendar
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.setCalDate = function (data, evt) {
    // Create a new Date object from the date contained in the bound observable data
    var bFound = false,
      bRequestAppointments = false,
      dt = null,
      i = 0,
      now = new moment(data.date);

    // Because the event can come from either the calendar month interface or
    // the minicalendar, we have to account for 2 different views.
    switch (self.calendarViewType()) {
      // If the calendar view is currently a full month calendar, we only
      // need to refresh the appointments if the new date sets our calendar
      // outside what is currently shown, in order to reduce service calls
      // against the server
      case 'month':
        if ((now.month() + 1) != self.cal.monthNumber()) {
          bRequestAppointments = true;
        }
        break;

      // If the current view is week, the event is more likely to have come
      // from the minicalendar. This could affect either the appointments or
      // possible time blocks. We examine the new date and if it is not found
      // in the currentWeek dates, then we will request new appointments or
      // possible time blocks, based on the globaViewType
      case 'week':
        for (i = 0; i < 7; i++) {
          dt = new moment(self.currentWeek().days[i].date);

          if (dt.isSame(now, 'day')) {
            bFound = true;
            break;
          }
        }

        if (bFound == false) {
          bRequestAppointments = true;
        }

        break;

      case 'day':
        bRequestAppointments = true;
        break;
    }

    // Update the main and mini calendars to the newly chosen date
    self.minical.buildMonth(now, true);
    self.cal.buildMonth(now, true);

    // If we found a need to update the appointments, determine whether we need
    // appointments (calendar view) or possible time blocks (add appointment view)
    if (bRequestAppointments) {
      if (self.globalViewType() == 'addAppointment' && evt != 'false') {
        self.possibleTimeBlocksWS.doRequest();
      }
      else if (self.globalViewType() == 'calendars') {
        self.appointmentsWS.doRequest();
      }
    }

    // Once the main calendar has been moved, update the observable variables
    // to reflect the current state in the UI
    self.updateCurrentDate();
  };


  /**
  * Takes the selected OAuth (oauthWS.oAuthSel) and creates a resource set out of them.
  *
  * @method setCalendarExportAssociation
  * @return none
  */
  self.setCalendarExportAssociation = function () {
    var existingAssoc = null,
      icsUrl = '/qless/api/v1/employee/icaldownload/resources/{0}/{1}',
      resourceIds = self.iCalSelectedResources(),
      oAuth = null,
      oAuthSelId = self.oauthWS.oAuthSel();

    // Microsoft Outlook Temporary ICS download
    if (oAuthSelId === true) {
      icsUrl = icsUrl.replace('{0}', self.iCalSelectedResources().join(',')).replace('{1}', escape(self.oauthWS.newConnectionName().replace(' ', '_')));
      document.location.href = icsUrl;
    }
    else {
      oAuth = self.oauthWS.getAuthById(oAuthSelId);
      existingAssoc = self.resourceSetWS.getSetByName(oAuth.name);

      if (resourceIds.length > 0 && oAuth) {
        // If there is already an association connected to this OAtuh, remove it
        // before adding the new selection
        if (existingAssoc) {
          self.resourceSetWS.removeAssociation(existingAssoc.id, function () {
            self.resourceSetWS.addResourceSet(resourceIds, oAuth.name);
          });
        }
        // Otherwise we are clear to add the selection.
        else {
          self.resourceSetWS.addResourceSet(resourceIds, oAuth.name);
        }
      }
    }
  };


  /**
  * Click-handled function
  * This method responds to a click on a possible time block when creating
  * a new appointment. This will be the final action of the create new
  * appointment action. By clicking on a possible time block, the start time
  * will be set and the process of submitting data to the services will begin.
  *
  * @method setNewAppointmentTime
  * @param {Object} data related to the object that was clicked (TimeBlockModel)
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.setNewAppointmentTime = function (data, evt) {
    if (self.globalViewType() === 'addAppointment') {
      var oApptTkt = self.addAppointmentTicket;

      $('.sidebar-addappointment').scrollTop(0);

      // Set the start time of the appointment.
      self.addAppointmentTicket.start(data.start());

      // Update the consumer info first, so that even if the appointment fails the
      // merchant has still recorded the updated consumer information.
      self.updateConsumerInfoWS.clearParams();
      self.updateConsumerInfoWS.addParam('phone', self.getPhoneWithCountryCode(oApptTkt.phone(), oApptTkt.location().defaultPhoneCountryCode));

      if (oApptTkt.firstName() != null) {
        self.updateConsumerInfoWS.addParam('firstName', oApptTkt.firstName());
      }

      if (oApptTkt.lastName() != null) {
        self.updateConsumerInfoWS.addParam('lastName', oApptTkt.lastName());
      }

      if (oApptTkt.email() != null) {
        self.updateConsumerInfoWS.addParam('email', oApptTkt.email());
      }

      if (oApptTkt.notes() != null) {
        self.updateConsumerInfoWS.addParam('notes', oApptTkt.notes());
      }

      // Set the callback handler on the doRequest method to actually push the
      // appointment to the web service.
      self.updateConsumerInfoWS.doRequest(function () {
        qcal.addAppointmentWS.sendTicket(qcal.addAppointmentTicket);
      });
    }
  };


  /**
   * Sets the resourceWeek observable to a range of dates
   * to be used when determining what the subtraction/holiday
   * events will send as parameters
   *
   * @method setResourceWeek
   * @param [Number] direction
   * @returns none
   */
  self.setResourceWeek = function (direction) {
    var days = [];

    if (isNaN(direction)) {
      direction = null;
    }

    var now = new moment();
    var sunday = now.startOf('week');

    var today = (self.resourceWeek().length > 0) ? self.resourceWeek()[0] : new moment();
    var from_date = (direction) ? today.startOf('week') : sunday.clone();

    self.resourceWeek.removeAll();

    if (direction) {
      if (direction > 0) {
        from_date.add(direction, 'weeks');
      }
      else if (direction < 0) {
        from_date.subtract(Math.abs(direction), 'weeks');
      }

      if (from_date.isBefore(sunday)) {
        from_date = sunday.clone();
      }
    }

    days.push(from_date);

    for (var i = 1; i < 7; i++) {
      var day = from_date.clone();
      day.add(i, 'days');
      days.push(day);
    }

    self.resourceWeek(days);
    self.resourceAvailabilityWS.doRequest();
  };


  /**
  * Click-handled function
  * This method responds to a button in the UI's header and sets the interface
  * for managing resources
  *
  * @method showResourceList
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return {Boolean} false
  */
  self.showResourceList = function (data, evt) {
    if (self.isResourceAdmin() == true) {
      self.setResourceWeek();
      self.toggleOpenAvailability(false);
      self.resourceViewType('list');
      self.globalViewType('resources');
    }

    return false;
  };


  /**
   * Click-handled function
   * This method responds to a button in the UI's toolbar and sets the
   * calendarViewType observed variable to that type. Data-bound UIs are
   * updated as a result of this variable change
   *
   * @method switchActiveView
   * @param {Object} data not used
   * @param {Event} evt The UI event which triggered the call to the function
   * @return none
   */
  self.switchActiveView = function (data, evt) {
    // If the button has a class .btn-disabled, ignore the click
    // return true to allow for event bubbling
    if (!($(evt.target).hasClass('btn-disabled') || $(evt.target).parent().hasClass('btn-disabled') || evt.target.innerHTML == self.calendarViewType())) {
      // Read the string from the innerHTML of the element clicked and
      // use that as the view type
      self.calendarViewType(evt.currentTarget.getAttribute('data-viewType'));

      // Request a new batch appointments to match the current view
      self.appointmentsWS.doRequest();

      // Set a cookie that can be recalled later
      self.setSticky('activeview', evt.currentTarget.getAttribute('data-viewType'));

      // Set the view to the current hour
      self.scrollInitialView(false);

      self.resetDayViewInterface();
    }
  };


  /**
  * Flips the value which determines if the message showing confirmation of the iCal export
  * should be displayed or not.
  *
  * @method toggleICalConf
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.toggleICalConf = function (data, evt) {
    self.oauthWS.oAuthSel(null);
    self.iCalConf(false);
  };


  /**
   * Click-handled function
   * Shows/Hides the location selector interface on the sidebar
   *
   * @method toggleLocationSelector
   * @param {Object} data not used
   * @param {Event} evt The UI event which triggered the call to the function
   * @return none
   */
  self.toggleLocationSelector = function (data, evt) {
    self.showLocationSelector(!self.showLocationSelector());
  };


  /**
   * Shows/hides the interface to select options for open avaialbility
   *
   * @method toggleOpenAvailability
   * @param {Boolean} force
   * @returns none
   */
  self.toggleOpenAvailability = function (force) {
    if (force !== undefined && force !== null && typeof force === 'boolean') {
      self.showOpenAvailability(force);
    }
    else {
      self.showOpenAvailability(!self.showOpenAvailability());
    }

    if (!self.showOpenAvailability()) {
      self.globalViewType('calendars');
    }
    else {
      self.globalViewType('openavailability');
    }

    self.openAvailabilityVM.reset();
  };


  /**
   * Flips the value which determines if the new OAuth screen is shown or not
   *
   * @method toggleShowNewAuth
   * @param {Object} data not used
   * @param {Event} evt The UI event which triggered the call to the function
   * @return none
   */
  self.toggleShowNewAuth = function (data, evt) {
    self.icalShowNewAuth(!self.icalShowNewAuth());
  };


  /**
   * Checks or unchecks all resource options in the sidebar
   *
   * @method toggleSidebarResources
   * @return none
   */
  self.toggleSidebarResources = function () {
    // Find out if all the sidebar resources are available in
    // the selected resources collection
    var sidebarResourceIds = self.sidebarResources().reduce(function (arr, res) {
      arr.push(res.id);
      return arr;
    }, []);
    var matchedResources = self.selectedResources().filter(function (id) {
      return sidebarResourceIds.indexOf(Number(id)) > -1;
    });

    var arr = self.selectedResources();

    sidebarResourceIds.forEach(function (id) {
      arr = arr.filter(function (i) {
        return Number(i) !== Number(id);
      });
    });

    if (sidebarResourceIds.length !== matchedResources.length) {
      sidebarResourceIds.forEach(function (id) {
        arr.push(String(id));
      });
    }

    self.selectedResources(arr);
  };


  /**
  * Click-handled function
  * Returns the user to the previously viewed interface.
  *
  * @method toolbarBack
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.toolbarBack = function (data, evt) {

    if (self.globalViewType() === 'searchResults') {
      self.searchFor(null);
      self.searchWS.reset();
      self.globalViewType('calendars');
      self.appointmentsWS.doRequest();
    }
    // If this is the first resource screen, set the global view back to
    // a calendar
    else if (self.resourceViewType() === 'list') {
      self.globalViewType('calendars');
      self.appointmentsWS.doRequest();
    }
    else if (self.resourceViewType() == 'availability') {
      if (self.resourceAvailabilityWS.modelChanged()) {
        self.availabilityConfirmSave();
      }
      else {
        self.resourceAvailabilitySaved();
      }
    }

  };


  /**
  * Click-handled function
  * Mathod to call toolbarBack with an additional parameter
  *
  * @method toolbarBackConfirm
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return none
  */
  self.toolbarBackConfirm = function (data, evt) {
    self.selectedResource(null);
    self.resourceAvailabilityWS.reset();
    self.resourceViewType('list');
    self.availabilityConfirmSaveHide();
  };



  ///
  /// METHODS
  ///




  /**
  * Method to determine if all consumer info fields have been filled in
  *
  * @method addAppointmentConsumerInfoComplete
  * @return {Boolean}
  */
  self.addAppointmentConsumerInfoComplete = function () {
    var oApptTckt = self.addAppointmentTicket;
    // Presently, all that is required is a valid phone number and one of the name fields filled in.
    if (self.phoneValid(oApptTckt.phone())
        && (self.consumerInfoValid(oApptTckt.firstName()) || self.consumerInfoValid(oApptTckt.lastName()))
        && (!self.addAppointmentTicket.location().emailRequired() || self.consumerInfoValid(oApptTckt.email(), 'email'))
        && (!self.addAppointmentTicket.usePartySize() || self.rangeIsValid(self.addAppointmentTicket.partySize(), self.addAppointmentTicket.minPartySize(), self.addAppointmentTicket.maxPartySize()))) {
      return true;
    }

    return false;
  };


  self.rangeIsValid = function(value, min, max) {
    return min <= value && value <= max;
  }

  /**
  * Method to determine if consumer info fields have any data
  * Rather than show/hide these fields if a user changes the queue, location, or TT,
  * once these fields have any data, they should remain visible until the form is closed
  *
  * @method addAppointmentConsumerInfoStarted
  * @return {Boolean}
  */
  self.addAppointmentConsumerInfoStarted = function () {
    var fields = $('.add-appointment-consumerinfo input'),		// Fields to be filled in by user
      i = 0,													// Standard increment
      sVal = null;											// Value held in field

    // Loop over each field; if any have a non-null/non-space value, return true
    for (i = 0; i < fields.length; i++) {
      val = $.trim($(fields[i]).val());

      if (val != '' && val != null) {
        return true;
      }
    }

    return false;
  };


  /*
  * Method to retrieve all the appointments on a given calendar date
  *
  * @method appointmentsMonthDate
  * @param {Date} oDate Javascript Native Date object
  * @return {Array} collection of AppointmentModels
  */
  self.appointmentsMonthDate = function (oDate) {
    var aReturn = [],
      dt = oDate.date.date(),
      tz = self.timeZoneControl.selectedTZ();

    // If there is a timezone, make sure the week date is adjusted to match
    if (tz) {
      // Shift the timezone
      oDate.date.tz(tz.olson[0]);
      // Reset the hour back to midnight
      oDate.date.hours(0);
      // The date can get shifted when TZs cross GMT
      // Make sure the date remains the same
      oDate.date.date(dt);
    }

    // Only bother requesting appointments if there are any to request and
    // the view is appropriate to show them
    if (self.selectedLocationIds().length > 0 && self.globalViewType() == 'calendars' && self.calendarViewType() == 'month') {
      aReturn = ko.observableArray(self.appointmentsWS.getAppointmentsByDate(oDate.date));
    }

    return aReturn;
  };


  /*
  * Presents an interface allowing the user to specify the AvailabilityModel
  * options for a resource
  *
  * @method availabilityConfirmSave
  * @return none
  */
  self.availabilityConfirmSave = function () {
    var bodyHeight = $('body').outerHeight(),
      bodyWidth = $('body').outerWidth(),
      elTgt = $('.availability-save-prompt'),
      elTgtW = elTgt.outerWidth(),
      elTgtH = elTgt.outerHeight(),
      tgtX = (bodyWidth / 2) - (elTgtW / 2);
    tgtY = (bodyHeight / 2) - (elTgtH / 2);

    // evt.stopPropagation();

    elTgt.css({
      top: tgtY + 'px',
      left: tgtX + 'px'
    });

  };


  /*
  * Removes the interface allowing the user to specify the AvailabilityModel
  * options for a resource
  *
  * @method availabilityConfirmSaveHide
  * @return none
  */
  self.availabilityConfirmSaveHide = function () {
    var elTgt = $('.availability-save-prompt');

    elTgt.css({
      top: '-2000px',
      left: '-2000px'
    });
  };


  /**
  * This method is a callback handler for once locations data has finished loading
  * The interface needs to select all the available locations and then set off
  * iterating each location in order to pull back the queue information for each
  *
  * @method callbackLocationsLoaded
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.callbackLocationsLoaded = function () {
    var aLocIds = [];
    var obj = {};

    // Load the message bundles
    self.messagesWS.doRequest(function () {
      // Set the variable which will invoke a computed recalculation

      // Replace the appointment statuses array with localized strings
      self.loadLocalizedAppointmentStatuses();

      // Loop over all tokens looking for Feature Toggle (FT) tokens
      var tokens = [].slice.call($(qcal.messagesWS.bundle()).find('m'));
      // If tokens were found, process them
      if (tokens) {
        // Loop over each token
        tokens.forEach(function (token) {
          var n = token.getAttribute('n')
          // Feature toggle messages will be prepeded 'FT'
          if (n.indexOf('FT') == 0) {
            obj[n.replace(/^FT/, '')] = self.parseValue(token.textContent);
          }
        });
      }

      // Set the variable which will invoke a computed recalculation
      self.featureToggles(obj);
    });

    // Get all the queues for all locations.
    // This change was made to put this call here so that only locations
    // that have queues with appointments will be presented to the user
    aLocIds = self.locationsWS.locationIds();

    // Load the queue data for all locations
    self.queuesWS.locationIds(aLocIds);

    clearTimeout(self.queueRequestTimeout);

    // if ( aLocIds.length > 0 ) {
    self.queueRequestTimeout = setTimeout(self.queuesWS.doRequest, 500);
    // }
    // else {
    // 	self.appointmentsWS.appointments.removeAll();
    // }

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method is a callback handler for once queues data has finished loading
  *
  * @method callbackQueuesLoaded
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.callbackQueuesLoaded = function () {

    self.resourcesWS.doRequest(function () {
      // See if the application is being returned from an OAuth trip
      if (self.getQueryParam('oauth') == 'complete') {
        document.getElementById('iCalButton').click();
      }
    });

    self.appointmentsWS.doRequest();

    // Set the current hour indicator and create an interval
    self.updateHourIndicator(true)
    window.setInterval(self.updateHourIndicator, 60000);

    // Scroll the view to the current hour
    self.scrollInitialView();
    //});

    self.setInitialLocations();

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * Clears the status message after a specified period of time
  *
  * @method clearStatusMessage
  * @param {Integer} iWait milliseconds before the message is cleared; default 1000
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.clearStatusMessage = function (iWait) {
    if (!iWait) {
      iWait = 1000;
    }

    clearTimeout(self.clearStatusMessageTimer);

    self.clearStatusMessageTimer = setTimeout(function () {
      qcal.statusMessage(null);
    }, iWait);

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method inspects consumer entered data in the add appointment interface to
  * ensure it meets the minimum entry requirements
  *
  * @method consumerInfoValid
  * @param {String} sValue String to be inspected
  * @param {String} sName Type of input
  * @return {Boolean}
  */
  self.consumerInfoValid = function (sValue, sName) {
    if (sValue) {
      if (sName && sName.toLowerCase() == 'email') {
        return self.emailValid(sValue);
      }
      return (sValue && sValue.length > 0);
    }
    return false;
  };


  /**
  * This method attempts to copy a text string from a UI element into
  * the user's clipboard. If successful, the 'copy to clipboard' string
  * will be updated with a success message, else it will be updated to
  * reflect that copying to the clipboard is not supported in their browser.
  *
  * @method copyIcalToClipboard
  * @param {Object} data not used
  * @param {Event} evt The UI event which triggered the call to the function
  * @return false to prevent default browser click handler
  */
  self.copyIcalToClipboard = function (data, evt) {
    var bSuccess = false,						// Whether the copy to clipboard was successful
      sMsg = '',								// The message to show about the copy operation
      sOriginalText = evt.target.innerHTML;	// The original text of the link

    // Select all the generated text in the iCalUrl input
    document.getElementById('icalLink').select();

    // Attempt to copy the text to the clipboard. If the browser does not
    // support this, it will return either an error or bomb. If it bombs
    // it will be caught by the error handler
    try {
      // Whether the command was successful
      bSuccess = document.execCommand('copy');

      // Create a feedback message for the user based on the succedd
      if (bSuccess) {
        sMsg = self.messagesWS.get('calendar.ical.copy.success');
      }
      else {
        sMsg = self.messagesWS.get('calendar.ical.copy.fail');
      }
    }
    catch (err) {
      // The operation bombed and is probably not supported by the browser
      sMsg = self.messagesWS.get('calendar.ical.copy.fail');
    }

    // Replace the text in the link with a feedback message
    evt.target.innerHTML = sMsg;

    // Put the original "copy to clipboard" message back in the link after 3 seconds.
    setTimeout(function () {
      evt.target.innerHTML = sOriginalText;
    }, 3000);

    // Return false to prevent default browser click handler
    return false;
  };


  /**
  * Returns the localized column name over each day column in the month view
  *
  * @method dayColumnName
  * @param {Integer} iDayNum Integer corresponding to the day of the week (0-6)
  * @return {String}
  */
  self.dayColumnName = function (iDayNum) {
    return self.currentWeek().days[iDayNum].date.format('ddd');
  };


  /**
  * Returns the localized first initial for the day of the week specified
  *
  * @method dayNameInitial
  * @param {Integer} iDayNum Integer corresponding to the day of the week (0-6)
  * @return {String}
  */
  self.dayNameInitial = function (iDayNum) {
    var m = new moment();
    m.day(iDayNum);

    return m.format('dd').substring(0, 1);
  };


  /**
  * This method compares a date object (data-bound) to the current date
  * and determines if the dates match.
  * This method is used in the minical and main calendar view to highlight
  * the current date
  *
  * @method dayIsToday
  * @param {Object} data KOCalendar data-bound Date object
  * @return {Boolean} Returns whether the date is the same as the current date
  */
  self.dayIsToday = function (data) {
    return data.date.isSame(self.cal.today(), 'day');
  };

  self.dragBlock = function (data, evt) {
    evt.stopImmediatePropagation();
  };

  self.dragEnd = function (data, evt) {
    if (!$(evt.target).hasClass('availability-drag')) {
      return;
    }

    var oldY = self.dragStartY();
    var newY = evt.screenY;

    self.dragStartY(null);
    evt.stopImmediatePropagation();
  };

  self.dragStart = function (data, evt) {
    if (!$(evt.target).hasClass('availability-drag')) {
      return;
    }

    self.dragStartY(evt.screenY);
    evt.stopImmediatePropagation();
  };

  self.handleDrag = function (data, evt) {
    if (self.dragStartY()) {
    }
  }


  /**
  * Helper function to validate user supplied email address
  *
  * @method emailValid
  * @param {String} sEmail
  * @return {Boolean} Returns whether the supplied email address appears valid.
  */
  self.emailValid = function (sEmail) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(sEmail);
  };


  /**
  * Attempts to read the first language from the user's browser
  *
  * @method getDefaultLanguage
  * @return {String}
  */
  self.getDefaultLanguage = function () {
    // default language
    var lang = 'en';
    var parts = [];

    if (navigator) {
      if (navigator.languages) {
        lang = navigator.languages[0];
      }
      else if (navigator.language) {
        lang = navigator.language;
      }
    }

    lang = lang || 'en';

    // clean up any hyphenated language strings
    parts = lang.split(/[-\_]/);
    lang = parts[0];

    // Default language
    return lang;
  };


  /**
  * Helper function to determine the phone number with a country code prepended
  *
  * @method getPhoneWithCountryCode
  * @param {String} sPhone A Phone number to format
  * @param {String} sCode A country code to prepend
  * @return {String} phone number prepended with the  country code
  */
  self.getPhoneWithCountryCode = function (sPhone, sCode) {
    sPhone = (sPhone) ? $.trim(sPhone) : '';

    if (sPhone != '' && sCode) {
      if (sPhone.length <= 10) {
        sPhone = '+' + sCode + sPhone;
      }
      else if (sPhone.charAt(0) == '0') {
        sPhone = '+' + sCode + sPhone.substring(1);
      }
    }

    return sPhone;
  };


  /**
  * Function to return the localized hour numbers for display in the interface
  *
  * @method hourLabel
  * @param {Integer} iHour The hour number to convert into a localized string ( 0 - 23 )
  * @return {String} Localized hour number string
  */
  self.hourLabel = function (iHour) {
    var tz = self.timeZoneControl.selectedTZ(),
      dDate = new moment();

    if (tz) {
      dDate.tz(tz.olson[0])
    }

    dDate.minutes(0);
    dDate.hours(iHour);

    return dDate.format('LT');
  };


  /**
  * This method starts the Qless Calendar experience. Once the QCalViewModel
  * has been created and data-bound to the UI, this method creates the initial
  * date and calls required Web Services to retrieve data
  *
  * @method init
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.init = function () {
    if (self.isAuthenticated()) {
      var sGVT = null;			// Parameter to drive the Global View Type

      // Determine the browser's first language;
      self.locale(self.getDefaultLanguage());

      // Set the initial date to today
      self.jumpToToday();

      // Restore any 'sticky' interface elements
      self.initStickyState();

      // Get a WSSID in order to POST data to the server
      self.wssidWS.doRequest(undefined, function () {
        var wssid = this.wssidWS.wssid()
        var linebuster = new LinebusterAPI();
        var environmentProperties = this.environmentProperties; 

        linebuster.apis.employee.environmentProperties(wssid).then(function (fetchedProperties) {
          environmentProperties(Object.assign(environmentProperties(), fetchedProperties))
        })
      }.bind(self))


      // Now call some services to get some data.
      // Call the authInfoWS to determine the roles of the authenticated user
      self.authInfoWS.doRequest();

      // Call is the locations service, to return a list of all the locations
      // available to the logged in merchant account
      // Pass a reference to the toggleAllLocations method, so that all the locations
      // will be selected after they are retrieved.
      self.locationsWS.doRequest(self.callbackLocationsLoaded);

      // Render the hour indicator
      self.updateHourIndicator();

      // Debug assist
      // Enables two different parameters to be passed to drive the initial view
      sGVT = self.getQueryParam('view');

      if (sGVT != null && sGVT != '') {
        self.globalViewType(sGVT);
      }

      // Populate availability hours with the localized time string
      self.populateAvailabilityHours();

      // Check for release notes
      self.releaseNotesVM.init();

      // Start the event connection
      self.event.start();
    }
    else {
      document.location.replace('/calendar/logout');
    }



    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method restores the UI to any state previously recorded by a cookie
  *
  * @method initStickyState
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.initStickyState = function () {
    var activeView = cookies.get('activeview'),
      resourceToggle = cookies.get('hide-resource-view'),
      legendToggle = cookies.get('hide-legend-view');

    if (activeView) {
      $('.mainview-option-' + activeView).click()
    }

    if (resourceToggle) {
      document.getElementById('hide-resource-view').checked = resourceToggle;
    }

    if (legendToggle) {
      document.getElementById('hide-legend-view').checked = legendToggle;
    }

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
   * Replaces strings in appointmentStatuses with
   * localized versions from the message bundle
   */
  self.loadLocalizedAppointmentStatuses = function () {
    self.appointmentStatusObjs([
      {
        name: self.messagesWS.get('appointment.status.pending'),
        val: 'PENDING'
      },
      {
        name: self.messagesWS.get('appointment.status.approved'),
        val: 'APPROVED'
      },
      {
        name: self.messagesWS.get('appointment.status.rejected'),
        val: 'REJECTED'
      }
    ]);
  };


  /**
  * Method to provide the month name string from the message
  * bundle for localized support
  *
  * @method monthName
  * @param {Integer} iMonth Month number ( 1 - 12 )
  * @param {Boolean} bAbbreviated If true, returns the abbreviated name
  * @return {String}
  */
  self.monthName = function (iMonth, bAbbreviated) {
    var tz = self.timeZoneControl.selectedTZ(),
      dDate = new moment(),
      format = (bAbbreviated) ? 'MMM' : 'MMMM';

    if (tz) {
      dDate.tz(tz.olson[0]);
    }

    dDate.month(iMonth - 1);

    return dDate.format(format);
  };




  self.oAuthHasAssociation = function (oAuth) {
    return !!self.resourceSetWS.getSetByName(oAuth.name);
  };


  /**
  * This method validates phone entry input in the add appointment interface
  *
  * @method phoneValid
  * @param {String} sPhone Phone number read from the phone input value
  * @return {Boolean}
  */
  self.phoneValid = function (sPhone) {
    var loc = self.addAppointmentTicket.location(),
      bAllowPhoneStart0 = (['1', '34'].indexOf(loc.defaultPhoneCountryCode) > -1 || loc.defaultPhoneCountryCode == null) ? false : true,
      bAllowPhoneStart1 = (loc.defaultPhoneCountryCode !== '1' && loc.defaultPhoneCountryCode != null),
      value = sPhone,
      inputMask = self.phoneMask(),
      re = new RegExp('[^#]', 'g'),
      testVal = self.getPhoneWithCountryCode(sPhone, loc.defaultPhoneCountryCode);


    if (value && value.length == 1) {
      if ((value == '1' && !bAllowPhoneStart1) || (value == '0' && !bAllowPhoneStart0)) {
        self.addAppointmentTicket.phone(null);
        return false;
      }
    }
    else if (value && value.length > 0) {
      if ((value.charAt(0) == '1' && !bAllowPhoneStart1) || (value.charAt(0) == '0' && !bAllowPhoneStart0)) {
        return false;
      }

      if (self.phoneMask() == null) {
        // Make sure the entered characters are only numbers
        value = sPhone.replace(new RegExp('[^0-9\-]', 'g'), '');
        self.addAppointmentTicket.phone(value);

        return (testVal.charAt(0) == '1' && testVal.length == 11 || testVal.charAt(0) != 1 && testVal.length > 9);
      }
      else {
        value = sPhone.replace(new RegExp('\\D', 'g'), '');
        if (value.length == self.phoneMask().replace(re, '').length) {
          return true;
        }
      }

      return false;
    }

    return false;
  };


  /**
  * Populates the array of availabilityHours
  *
  * @method processEventResponse
  * @return none
  */
  self.populateAvailabilityHours = function () {
    var dt = new moment();

    dt.minutes(0);
    dt.seconds(0);

    for (i = 0; i < 24; i++) {
      dt.hours(i);

      self.availabilityHours.push({
        value: i,
        display: dt.format('LT')
      })
    }
  };

  /**
  * Handler to allow user to print currently displayed appointments in calendar view
  * TODO: In the future this could be extended to print both week and month view.
  *
  * @method printDisplayedAppointments
  * @return none
  */

  self.printDisplayedAppointments = function () {
    self.appointmentsPrinter.print(self.cal.today(),
                                   self.selectedQueueIds(),
                                   self.selectedLocationIds(),
                                   self.timeZoneControl.selectedTZ().names,
                                   self.locale());
  }

  /**
  * Handles events received from the event connection
  *
  * @method processEventResponse
  * @return none
  */
   self.processEventResponse = function () {
    var aRecognizedEvents = ['APPOINTMENT_SCHEDULED', 'APPOINTMENT_CANCELED', 'APPOINTMENT_UNCANCELED', 'APPOINTMENT_APPROVED', 'APPOINTMENT_REJECTED', 'APPOINTMENT_PENDING', 'APPOINTMENT_SERVED_EARLY', 'APPOINTMENT_CHECKED_IN', 'APPOINTMENT_FAILED', 'APPOINTMENT_QUEUED'];

    var queueId = arguments[1]
    var queueEventLocationId = String(self.queuesWS.getQueue(queueId).locationId);

    if (self.selectedLocationIds().indexOf(queueEventLocationId) > -1) {
      if (arguments.length > 0 && aRecognizedEvents.indexOf(arguments[0]) > -1) {
        self.appointmentsWS.doRequest();
      }
    }

  };


  /**
   * This method resets the CI window and asks for current data
   *
   * @method resetCi
   * @returns none
   */
  self.resetCi = function () {
    self.calendarIntegrationVM.getResources();
  };


  /**
  * This method resets the iCal export window to default options
  *
  * @method resetIcal
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.resetIcal = function () {
    // Remove any previously selected options
    self.iCalSelectedResources.removeAll();

    // Get existing resource selections
    self.resourceSetWS.getResourceSets(function () {
      //get existing resource set -> OAuth associations
      self.resourceSetWS.getResourceAssociations();
    });


    // Add the first (default) option
    self.iCalSelectedResources.push(self.iCalResources()[0]);

    // Ask for the iCal URL to be generated once the window is instantiated
    // self.generateICalUrl();

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * Clean-up action to run after the resourceAvailabilityWS has saved data
  *
  * @method resourceAvailabilitySaved
  * @return none
  */
  self.resourceAvailabilitySaved = function () {
    self.availabilityConfirmSaveHide();
    self.selectedResource(null);
    self.resourceAvailabilityWS.reset();
    self.resourceViewType('list');
  };


  /**
   * Returns the formatted string to display above the
   * column for resource availability
   *
   * @method resourceWeekColumnLabel
   * @param {Moment} data
   * @returns {String}
   */
  self.resourceWeekColumnLabel = function (data) {
    return data.format('ddd MMM D');
  };


  /**
  * This method scrolls the week or day view to the current hour OR the first
  * appointment block, whichever is later
  *
  * @method scrollInitialView
  * @param {Boolean} bAnimate whether to animate the new position, default: true
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.scrollInitialView = function (bAnimate) {
    var now = new moment(),
      tz = self.timeZoneControl.selectedTZ();

    if (tz != null) {
      now.tz(tz.olson[0]);
    }

    self.scrollViewToHour(now, bAnimate);

    self.updateHourIndicator();

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method scrolls the week or day view to the specified hour of the supplied
  * native Javascaript Date object
  *
  * @method scrollViewToHour
  * @param {Moment} mDate
  * @param {Boolean} bAnimate whether to animate the new position, default: true
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.scrollViewToHour = function (mDate, bAnimate) {
    var now = mDate,			// The date passed
      hr = 0,					// The hour right now
      oHourTarget = null,		// The DOM label for the current hour
      $container = null,		// Container scroll amount
      containerId = null,
      iHourTop = 0,			// The y-pos of that hour DOM element
      iScrollAmount = 0,
      tz = self.timeZoneControl.selectedTZ();		// The amount the container is already scrolled

    self.timeZoneOffSet('-04:00');

    if (tz != null) {
      now.tz(tz.olson[0]);
    }

    hr = now.hours();

    // Only proceed if the current view type is scrollable
    if (['day', 'week'].indexOf(self.calendarViewType()) > -1) {

      // Determine which ID and element to operate within
      switch (self.globalViewType()) {
        case 'calendars':
          containerId = (self.calendarViewType() == 'week') ? 'weekHourContainer' : 'dayHourContainer';
          break;

        case 'resources':
          containerId = 'availabilityHourContainer';
          break
      }

      $container = $('#' + containerId);

      if ($container.length > 0) {

        // Find the corresponding hour label DOM element
        oHourTarget = $('#hourLabel' + hr, $container);

        // Determine the amount the container is already scrolled
        iScrollAmount = $container.scrollTop();

        // Determine the top position
        iHourTop = oHourTarget.position().top + iScrollAmount;

        if (bAnimate === false) {
          $container.scrollTop(iHourTop);
        }
        else {
          $container.animate({ scrollTop: iHourTop + 'px' });
        }

      }
    }

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * Method to fill in selected appointment with supplemental data from
  * disparate data resources
  *
  * @method selectAppointment
  * @param {AppointmentModel} data AppointmentModel that was clicked on in the interface
  * @return {QCalViewModel} Returns self as chainable, for best practice
  */
  self.selectAppointment = function (data) {
    var loc = qcal.locationsWS.indexedLocations()[data.locationId];
    data.locationName = loc.name;

    var q = qcal.queuesWS.indexedQueues()[data.queueId];
    data.queueName(q.description);
    data.phoneDigitCount(q.privatePhoneDigitCount);

    self.selectedAppointment(data);

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * jQuery method invoked on end of selcting elements within a jQuery UI Selectable element
  * Creates a new AvailabilityModel and adds it to the resourceAvailabilityWS availability() collection
  *
  * @method selectAvailabilityRange
  * @param {Event} evt Event object from the UI
  * @param {Object} ui null
  * @return {Boolean} false
  */
  self.selectAvailabilityRange = function (evt, ui) {
    // The jQuery.selectable.stop() event returns an event at the end of selecting.
    // Grab all the elements out of the UI with the CSS className .ui-selected
    // These elements can be parsed, a range interpreted, and then cleared of the class, as
    // the new range will be added as an AvailabilityModel to the class
    var aTimes = [];
    var els = $('.ui-selected');
    var dDate = null;
    var dStart = null;
    var i = 0;
    var iDuration = 0;
    var oAvailModel = new AvailabilityModel();
    var sStartDate = null;
    var sStartHour = null;
    var sStartMin = null;


    // Loop over each element found with a .ui-selected CSS className
    for (i = 0; i < els.length; i++) {
      // Extract the date/time information from each found element
      sStartDate = $(els[i]).attr('data-startDate');
      sStartMin = $(els[i]).attr('data-startMin');
      sStartHour = $(els[i]).attr('data-startHour');

      // Construct a date object based on the date and then set the hour
      // and minutes accordingly
      dDate = new Date(Date.parse(sStartDate));
      dDate.setMinutes(sStartMin);
      dDate.setHours(sStartHour);

      // Push the epoch time value of the date object into the aTimes array
      aTimes.push(dDate.valueOf());
    }

    // These times should be received in chronological order, but there is no
    // guarantee. Ensure that the dates are sorted earliest to latest.
    aTimes.sort();

    // Now determine the start time and duration of the range by looking at the
    // first and last times
    var dStart = new Date(aTimes[0]);
    iDuration = ((aTimes[aTimes.length - 1] - aTimes[0]) / (1000 * 60)) + 10;

    oAvailModel.startDate(dStart.toISOString().split('T').shift())
    oAvailModel.startHour(dStart.getHours());
    oAvailModel.startMinute(dStart.getMinutes());

    var dEnd = new Date();
    dEnd.setHours(dStart.getHours());
    dEnd.setMinutes(dStart.getMinutes() + iDuration);

    oAvailModel.end = dEnd.getHours() + oAvailModel.pad(dEnd.getMinutes(), 2);
    oAvailModel.endHour(dEnd.getHours());
    oAvailModel.endMinute(dEnd.getMinutes());

    oAvailModel.duration(iDuration);

    // Set the recurrence interval to weekly, by default
    oAvailModel.recurrenceInterval('weekly');

    // Set the recurrence to just the day that was initially created
    oAvailModel.recurrence.push($(evt.target).index().toString());

    // Create the bitmask for daysOfWeek
    oAvailModel.daysOfWeek = oAvailModel.dayBitMask();

    // Match the timezone to the location timezone
    oAvailModel.timeZone = self.selectedResourceTimeZone();

    oAvailModel.units = 'MINUTES';

    self.resourceAvailabilityWS.availability.push(oAvailModel);

    // Finally, reset the deck so new items can be parsed next time a selection is made.
    $('.ui-selected').removeClass('ui-selected');

    self.resourceAvailabilityWS.availability.valueHasMutated();

    return false;
  };


  /**
  * Sends confirmation email to the Consumer
  *
  * @method sendAppointmentConfirmationEmail
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.sendAppointmentConfirmationEmail = function () {
    self.appointmentConfirmationEmailWS.doRequest(self.addAppointmentWS.appointmentConfirmationCode(), self.addAppointmentTicket.language());

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method compares a date object (data-bound) to the current date
  * and determines if the dates match.
  * This method is used in the minical and main calendar view to highlight
  * the current date
  *
  * @method serviceColor
  * @param {Observable Object} index Contains integer of foreach loop
  * @return {String} Returns hexidecimal color string
  */
  self.serviceColor = function (index) {
    // Because index is data-bound, the value must be extracted
    var idx = index();

    return '#' + self.serviceColors[idx];
  };


  /**
   * Sends a specific date/time to the service to mark as a
   * holiday for the selected resource
   *
   * @method setHoliday
   * @param {Moment} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.setHoliday = function (data, evt) {
    evt.stopImmediatePropagation();
    evt.target.blur();

    if (data instanceof AvailabilityModel) {
      var resource = self.selectedResource();
      var day = self.resourceWeek()[self.availabilitySelectedDay()];

      if (resource) {
        var endHour = data.pad(data.endHour(), 2);
        var endMinute = data.pad(data.endMinute(), 2);
        var startHour = data.pad(data.startHour(), 2);
        var startMinute = data.pad(data.startMinute(), 2);

        var start = day.format('YYYY-MM-DD') + ' ' + startHour + ':' + startMinute + ':00';
        var end = day.format('YYYY-MM-DD') + ' ' + endHour + ':' + endMinute + ':59';

        var hol = self.resourceAvailabilityWS.unavailability.getHoliday(new moment(start), new moment(end));

        if (hol) {
          self.removeHoliday(hol);
        }
        else {
          self.resourceAvailabilityWS.holidayAdded(true);
          self.resourceAvailabilityWS.save();
          self.resourceAvailabilityWS.unavailability.add(self.selectedResource().id, start, end, self.selectedResourceTimeZone());
          setTimeout(function () {
            self.resourceAvailabilityWS.doRequest()
          }, 100);
        }
      }
    }
  };


  /**
   * Sends a specific date to the service to mark as a
   * holiday for the selected resource
   *
   * @method setDayHoliday
   * @param {Moment} data
   * @param {MouseEvent} evt
   * @returns none
   */
  self.setDayHoliday = function (data, evt) {
    evt.stopImmediatePropagation();
    evt.target.blur();

    var resource = self.selectedResource();

    if (resource) {
      var start = data.format('YYYY-MM-DD') + ' 00:00:00';
      var end = data.format('YYYY-MM-DD') + ' 23:59:59';


      var hol = self.resourceAvailabilityWS.unavailability.getFullHoliday(data);

      if (hol) {
        self.removeHoliday(hol);
      }
      else {
        self.resourceAvailabilityWS.unavailability.add(self.selectedResource().id, start, end, self.selectedResourceTimeZone());
      }
    }
  };


  /**
   * Sends a specific date to the service to remove as a
   * holiday for the selected resource
   *
   * @method removeHoliday
   * @param {Object} data
   * @returns none
   */
  self.removeHoliday = function (data) {
    var resource = self.selectedResource();

    if (resource) {
      self.resourceAvailabilityWS.unavailability.delete(data.id);
    }
  };


  /**
  * Method to set the selected location or present an interface to the
  * user to select locations they would like to see appointments for.
  *
  * @method setInitialLocations
  * @return none
  */
  self.setInitialLocations = function () {
    var i = 0,
      sCookieLocs = cookies.get('selectedLocationIds'),
      tArr = [];

    if (self.locations().length == 1) {
      self.showLocationSelector(false);
      self.selectedLocationIds([self.locations()[0].id.toString()]);
      return;
    }

    // Selected any cookied locations or all by default
    if (sCookieLocs != null && sCookieLocs != '') {
      sCookieLocs = sCookieLocs.toString().split('|');

      for (i = 0; i < sCookieLocs.length; i++) {

        if (self.locationsWS.locationIds().indexOf(parseInt(sCookieLocs[i])) > -1) {
          tArr.push(sCookieLocs[i])
        }

      }

      if (tArr.length > 0) {
        self.selectedLocationIds(tArr);
      }
    }
    else {
      if (self.locationsWS.locationIds().length == 1) {
        self.selectedLocationIds([self.locationsWS.locationIds()]);
      }
    }

    if (self.selectedLocationIds().length < 1) {
      self.showLocationSelector(true);
    }
  };


  /**
  * Adds CSS className to options after they have been rendered to the UI
  *
  * @method setOptionClass
  * @param
  * @return none
  */
  self.setOptionClass = function (option, item) {
    ko.applyBindingsToNode(option, { css: item.className }, item);
  };


  /**
  * Sets the status message to appear in the application header. Optionally sets a duration for the message
  *
  * @method setStatusMessage
  * @param {Number} sMsg String to present to the user
  * @param [Number] iWait milliseconds before the message is cleared
  * @return {QCalViewModel}
  */
  self.setStatusMessage = function (sMsg, iWait) {
    clearTimeout(self.clearStatusMessageTimer);

    self.statusMessage(sMsg);

    if (iWait) {
      self.clearStatusMessage(iWait);
    }

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method takes a name and value and sets a cookie
  * In the case a value is not directly passed, one will be interpreted
  *
  * @method setSticky
  * @param {String} sName Key for the cookie
  * @param {String} sValue Value for the cookie
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.setSticky = function (sName, sValue) {
    var el = null;

    // If the value is not defined, we need to interpret it
    if (!sValue) {
      el = document.getElementById(sName);

      if (el) {
        if (el.type == 'checkbox') {
          // The event fires before the checked property is set
          // so the inverse of the checked property is what the
          // new checked value will be.
          sValue = !el.checked;
        }
      }
    }

    // Now set the cookie
    if (sName && sValue !== null && sValue !== undefined) {
      cookies.set(sName, sValue);
    }

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * This method selects or deselects all locations. If all locations
  * are selected, each location wil be deselected. Otherwise, all
  * locations will be selected
  *
  * @method toggleAllLocations
  * @return {QCalViewModel}
  */
  self.toggleAllLocations = function () {
    var iLocLen = self.locations().length;
    var iSelLocLen = self.selectedLocationIds().length;

    // If the number of locations does not match the number of selected
    // locations then all locations need to be selected
    if (iLocLen != iSelLocLen) {
      // Loop over each location and push it's ID to the
      // selectedLocationIds observable
      var arr = self.locations().reduce(function (a, loc) {
        a.push(loc.id.toString());
        return a;
      }, []);

      self.selectedLocationIds(arr);
    }
    else {
      // Clear the location selection
      self.selectedLocationIds.removeAll();
    }

    return self;
  };


  /**
  * If the selected appointment status is REJECTED, asks user to confirm
  *
  * @method updateAppointmentCheck
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.updateAppointmentCheck = function () {
    if (self.selectedAppointment().status() == 'REJECTED') {
      self.editAppointmentConfirming(true);
    }
    else {
      self.updateAppointment();
    }
  };


  /**
  * This updates the views to represent the current date, as represented
  * by the main view calendar
  *
  * @method updateCurrentDate
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.updateCurrentDate = function () {
    // Update the observable variables to reflect the current date in the UI
    self.currentDate(self.cal.today().date());
    self.currentMonth(self.cal.today().month());
    self.currentYear(self.cal.today().year());

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  self.version = function () {
    return document.getElementById('pkg-version').dataset.version;
  }


  /**
  * Returns the current hour and minute as a structured object, taking into account
  * the user selected timezone, if different from the browser's actual TZ
  *
  * @method getCurrentTime
  * @return {Object}
  */
  self.getCurrentTime = function () {
    var now = new moment(),
      selTZ = self.timeZoneControl.selectedTZ();

    if (selTZ != null) {
      now.tz(selTZ.olson[0]);
    }

    self.now(now);

    return {
      hour: now.hour(),
      minute: now.minute()
    }
  }


  /**
  * This updates hour indicator line in week and day view. Typically set on
  * an interval, but can also be called directly.
  *
  * @method updateHourIndicator
  * @param {Boolean} bDoScroll Whether or not to scroll the interface
  * @return {QCalViewModel} Returns the view model as chainable, for best practice
  */
  self.updateHourIndicator = function (bDoScroll) {
    var now = self.getCurrentTime(),
      sContainerId = (self.calendarViewType() == 'week') ? 'weekHourContainer' : 'dayHourContainer',
      iScrollTop = $('#' + sContainerId).scrollTop(), // Container scroll amount
      oHourTarget = $('#hourLabel' + now.hour, '#' + sContainerId);

    // If there was no target, this is the calendar view, so ignore.
    if (oHourTarget) {
      try {
        iHourTop = oHourTarget.position().top;
        iHourHeight = oHourTarget.height();
        iMinutePct = now.minute / 60;

        // The new top position is determined by the amount the view has been
        // scrolled plus the top position of the hour label plus the height of
        // the hour label divided by the percentage of minutes in the hour
        iNewTop = iScrollTop + iHourTop + (iHourHeight * iMinutePct);

        // Finally set the position of the indicator
        $('.calendar-hour-indicator').css('top', iNewTop + 'px');

        // Scroll the view to the current time if it is not already scrolled
        if (bDoScroll) {
          self.scrollInitialView();
        }
      }
      catch (e) { }
    }

    // Return self (QCalViewModel) to be chainable, for best practice
    return self;
  };


  /**
  * Returns the localized column name over each day in the week view
  *
  * @method weekColumnName
  * @param {Date} data Javascript Native Date object
  * @return {String}
  */
  self.weekColumnName = function (data, bSimple) {
    var format = (bSimple) ? 'ddd' : 'ddd MMM D';

    return data.date.format(format);
  };


  /**
  * Subscribe to the locations. When they change, request the Merchant info
  *
  * @method locations.subscribe
  * @return none
  */
  self.locations.subscribe(function (val) {
    if (val && val.length > 0) {
      self.merchantWS.merchantId(val[0].merchantId);
      self.merchantWS.doRequest()
    }
  });


  /**
  * Subscribe to the selected time zone and when changed:
  * - Update the hour indicator
  * - Tell the appointment controller (AppointmentWS) to update all appointments
  *
  * @method timeZoneControl.selectedTZ.subscribe
  * @return none
  */
  self.timeZoneControl.selectedTZ.subscribe(function (val) {
    if (val) {
      // Force self.now to get updated inside the getCurrentTime() function
      self.getCurrentTime();

      // Reinitialize the calendar with the updated Moment
      self.cal.buildMonth(self.cal.today());

      // Reinitialize the minical with the updated Moment
      self.minical.buildMonth(self.cal.today(), true);

      self.updateHourIndicator();

      // Update the current models to represent the new time zone
      switch (self.globalViewType()) {
        case 'addAppointment':
          self.addAppointmentTicket.requestPossibleTimeBlocks();
          break;
      }

      self.cal.weeks.valueHasMutated();
    }
  });

  self.openAvailabilityVM = new OpenAvailabilityViewModel(self);
  self.calendarIntegrationVM = new CalendarIntegrationViewModel(self);

  /**
   * Get the date for the current day the Employee has interacted with
   * in the UI.
   *
   * @return string
   */
  self.selectedDate = function () {
    var selectedDay = self.availabilitySelectedDay()
    return (selectedDay) ? self.resourceWeek()[selectedDay].format("YYYY-MM-DD") : ""
  };

  // This acts a proxy, a middle-man between the UI drop-down to change
  // the recurrenceInterval and the actual property.
  //
  // Normally, when we bind the observable to the UI directly, Knockout
  // updates the observable BEFORE it sends the input's `change` event.
  //
  // This caused the `recurrenceInterval` to change before we could set
  // the `startDate` from the `selectedDate`. This caused the Availability
  // to not be rendered.
  //
  // So, to prevent this, we introduce this computed observable, that
  // Knockout will bind to, and we can coordinate the work of getting
  // the selected date and changing the interval.
  //
  self.proxySelectedAvailabilityRecurrenceInterval = ko.pureComputed({
    read: function ()  {
      var selectedAvailability = this.selectedAvailability()
      return (selectedAvailability) ? selectedAvailability.recurrenceInterval() : null;
    },
    write: function (recurrenceInterval) {
      var availability = this.selectedAvailability();

      if (availability) {
        var convertToNonRecurrence = (recurrenceInterval == "never" && availability.recurrenceInterval() != "never")

        if (convertToNonRecurrence) {
          availability.startDate(self.selectedDate())
        }

        availability.recurrenceInterval(recurrenceInterval)
      }
    },
    owner: this
  });

  // This KnockOut Computed Observable is another proxy. It provides a date to the
  // Availability Detail Modal's Datepicker. It either uses the Availability's
  // `startDate` if it exists, or a default date, the selected date
  // on the UI.
  self.proxyAvailabilityDate = ko.pureComputed({
    read: function() {
      var startDate = self.selectedAvailability().startDate();
      return (!startDate) ? self.selectedDate() : startDate;
    },
    write: function(startDate) {
      self.selectedAvailability().startDate(startDate);
    },
    owner: self
  });

};

QCalViewModel.prototype = Object.create({})
QCalViewModel.prototype.createServices = function () {
  // Service to send new appointment data to the server
  this.addAppointmentWS = new AddAppointmentWS(this);
  // Service to send email to Consumer after appointment is made
  this.appointmentConfirmationEmailWS = new AppointmentConfirmationEmailWS(this);
  // Service to obtain appointments for resources at this location/merchant
  this.appointmentsWS = new FlexAppointments(
    this,
    new AppointmentHeadersWS(this),
    new AppointmentDetailWS(this)
  );
  // this.appointmentsWS = new AppointmentsWS(this);
  // Service to obtain the user roles for the authenticated user
  this.authInfoWS = new AuthInfoWS(this);
  // Service to obtain a list of queues at a specified location
  this.queuesWS = new QueuesWS(this);
  // Service to retrieve a list of locations for the authenticated user
  this.locationsWS = new LocationsWS(this, this.queuesWS.getQueuesByLocationId.bind(this.queuesWS));
  // Service to retrieve data about the merchant
  this.merchantWS = new MerchantWS(this);
  // Service to retrieve a list of locations for the authenticated user
  this.messagesWS = new MessagesWS(this);
  // Service to retrieve calendar integration authorizations
  this.oauthWS = new OAuthWS(this);
  // Service to obtain the time blocks available for making a new appointment
  this.possibleTimeBlocksWS = new PossibleTimeBlocksWS(this);
  // Service to retrieve a Resource's availability
  this.resourceAvailabilityWS = new ResourceAvailabilityWS(this, this.resourceWeek);
  // Service to obtain a list of resources at this location/merchant
  this.resourcesWS = new ResourcesWS(this);
  // Service to retrieve a Resource's Unavailability
  this.resourceUnavailabilityWS = new ResourceUnavailabilityWS(this);
  // Service to locate appointments made for the Consumer
  this.searchWS = new SearchWS(this);
  // Service to obtain a list of service types at this location/merchant
  this.servicesWS = new ServicesWS(this, this.queuesWS);
  // Service to begin service on an appointment
  this.serviceTransactionStartWS = new ServiceTransactionStartWS(this);
  // Service to change the status of an existing appointment
  this.updateAppointmentStatusWS = new UpdateAppointmentStatusWS(this);
  // Service to update the consumer info when creating a new appointment
  this.updateConsumerInfoWS = new UpdateConsumerInfoWS(this);
  // Service to transaction changes in a Resource's AvailabilityModel
  this.updateResourceAvailabilityWS = new UpdateResourceAvailabilityWS(this);
  // Service to get the WSSID
  this.wssidWS = new WssidWS(this);

  // Manages Resource Sets for iCal export
  this.resourceSetWS = new ResourceSetWS(this);
}


/**
 * Shows the Edit Appointment Dialogue
 * @param  {AppointmentModel} appointment the Appointment to load.
 */
QCalViewModel.prototype.editAppointment = function (appointment) {
  // if (appointment) {
  //   console.log("Editing Apppointment", appointment.id)
  //   this.editAppointmentViewMode.edit(appointment)
  // }

  this.editAppointmentVM.show(appointment);
}

/**
 * 
 * @param {Event} event 
 * @returns 
 */
QCalViewModel.prototype.handleEditAppointment = function(data, event) {

  var self = this;

  this.toggleOpenAvailability(false);
  this.searchWS.reset();
  this.hideAllModals(null, event);
  this.modalHide();

  this.calendarViewType('week');
  this.globalViewType("editAppointment");
  this.setSticky('activeview', 'week');

  // Get the Appointment
  var appointment = new AppointmentModel();
  this.appointmentsWS.fetchAppointment(data.id, function (appointmentDetails) {
    setTimeout(function () {
      appointment.loadDetailsAndLanguageName(appointmentDetails, self.messagesWS)
      self.editAppointment(appointment);
      self.appointmentsWS.doRequest();
    })
  })
}

QCalViewModel.prototype.handleEditAppointmentClose = function () {
  this.globalViewType('calendars');
}

/**
 * @returns {Array}
 */
QCalViewModel.prototype._appointmentsViewMonth = function() {
  var appointmentsWS = this.appointmentsWS;

  // update whenever appointments or timezone changes
  var weeks = this.cal.weeks();
  var appointmentsDependency = appointmentsWS.appointments();
  var timeZoneDependency = this.timeZoneControl.selectedTZ();

  // Month View shows the weeks in the month and appointments per day:
  // Weeks > Days > Appointments

  var appointmentsForWeeksInMonth = weeks.map(function (week) {
    var appointmentsForDaysInWeek = week.days.reduce(function (days, day) {
      var appointmentsByStartTime = appointmentsWS.getAppointmentStartTimes(day.date);

      var appointments = [];
      for (var i = 0; i < appointmentsByStartTime.length; i++) {
        if (appointmentsByStartTime[i].appointments.length > 0) {
          appointments = appointments.concat(appointmentsByStartTime[i].appointments)
        }
      }

      days.push({
        "day": day,
        "appointments": appointments
      });

      return days;
    }, []);

    return {
      "week": week, "days": appointmentsForDaysInWeek 
    }
  })

  return appointmentsForWeeksInMonth;
}


if (typeof exports !== "undefined") {
  exports.QCalViewModel = QCalViewModel;
}
